/* eslint-disable */

// App
export const APP_SESSION_INFO_SET = 'APP_SESSION_INFO_SET';

export const APP_DOMAINS_PENDING = 'APP_DOMAINS_PENDING';
export const APP_DOMAINS_SUCCESS = 'APP_DOMAINS_SUCCESS';
export const APP_DOMAINS_FAILURE = 'APP_DOMAINS_FAILURE';

/*
  -----------------

  Itinerary

  -----------------
 */
export const ITINERARY_CLEAR_STATE = 'ITINERARY_CLEAR_STATE';

// Product Types
export const ITINERARY_PRODUCT_TYPES_PENDING = 'ITINERARY_PRODUCT_TYPES_PENDING';
export const ITINERARY_PRODUCT_TYPES_SUCCESS = 'ITINERARY_PRODUCT_TYPES_SUCCESS';
export const ITINERARY_PRODUCT_TYPES_FAILURE = 'ITINERARY_PRODUCT_TYPES_FAILURE';

// Itineraries
export const ITINERARY_OVERVIEW_PENDING = 'ITINERARY_OVERVIEW_PENDING';
export const ITINERARY_OVERVIEW_SUCCESS = 'ITINERARY_OVERVIEW_SUCCESS';
export const ITINERARY_OVERVIEW_FAILURE = 'ITINERARY_OVERVIEW_FAILURE';
export const ITINERARY_CREATE_PENDING = 'ITINERARY_CREATE_PENDING';
export const ITINERARY_CREATE_SUCCESS = 'ITINERARY_CREATE_SUCCESS';
export const ITINERARY_CREATE_FAILURE = 'ITINERARY_CREATE_FAILURE';
export const ITINERARY_LOAD_GENERAL_PENDING = 'ITINERARY_LOAD_GENERAL_PENDING';
export const ITINERARY_LOAD_GENERAL_SUCCESS = 'ITINERARY_LOAD_GENERAL_SUCCESS';
export const ITINERARY_LOAD_GENERAL_FAILURE = 'ITINERARY_LOAD_GENERAL_FAILURE';

export const ITINERARY_EDIT_PENDING = 'ITINERARY_EDIT_PENDING';
export const ITINERARY_EDIT_SUCCESS = 'ITINERARY_EDIT_SUCCESS';
export const ITINERARY_EDIT_FAILURE = 'ITINERARY_EDIT_FAILURE';

// Countries
export const ITINERARY_COUNTRIES_PENDING = 'ITINERARY_COUNTRIES_PENDING';
export const ITINERARY_COUNTRIES_SUCCESS = 'ITINERARY_COUNTRIES_SUCCESS';
export const ITINERARY_COUNTRIES_FAILURE = 'ITINERARY_COUNTRIES_FAILURE';
export const ITINERARY_MASTER_COUNTRIES_PENDING = 'ITINERARY_MASTER_COUNTRIES_PENDING';
export const ITINERARY_MASTER_COUNTRIES_SUCCESS = 'ITINERARY_MASTER_COUNTRIES_SUCCESS';
export const ITINERARY_MASTER_COUNTRIES_FAILURE = 'ITINERARY_MASTER_COUNTRIES_FAILURE';

// Sales countries
export const ITINERARY_SALES_COUNTRIES_PENDING = 'ITINERARY_SALES_COUNTRIES_PENDING';
export const ITINERARY_SALES_COUNTRIES_SUCCESS = 'ITINERARY_SALES_COUNTRIES_SUCCESS';
export const ITINERARY_SALES_COUNTRIES_FAILURE = 'ITINERARY_SALES_COUNTRIES_FAILURE';
export const ITINERARY_SALES_COUNTRIES_UPDATE_PENDING = 'ITINERARY_SALES_COUNTRIES_UPDATE_PENDING';
export const ITINERARY_SALES_COUNTRIES_UPDATE_SUCCESS = 'ITINERARY_SALES_COUNTRIES_UPDATE_SUCCESS';
export const ITINERARY_SALES_COUNTRIES_UPDATE_FAILURE = 'ITINERARY_SALES_COUNTRIES_UPDATE_FAILURE';

// Trip themes
export const ITINERARY_TRIP_THEMES_PENDING = 'ITINERARY_TRIP_THEMES_PENDING';
export const ITINERARY_TRIP_THEMES_SUCCESS = 'ITINERARY_TRIP_THEMES_SUCCESS';
export const ITINERARY_TRIP_THEMES_FAILURE = 'ITINERARY_TRIP_THEMES_FAILURE';
export const ITINERARY_TRIP_THEMES_ASSIGNED_PENDING = 'ITINERARY_TRIP_THEMES_ASSIGNED_PENDING';
export const ITINERARY_TRIP_THEMES_ASSIGNED_SUCCESS = 'ITINERARY_TRIP_THEMES_ASSIGNED_SUCCESS';
export const ITINERARY_TRIP_THEMES_ASSIGNED_FAILURE = 'ITINERARY_TRIP_THEMES_ASSIGNED_FAILURE';
export const ITINERARY_TRIP_THEMES_UPDATE_PENDING = 'ITINERARY_TRIP_THEMES_UPDATE_PENDING';
export const ITINERARY_TRIP_THEMES_UPDATE_SUCCESS = 'ITINERARY_TRIP_THEMES_UPDATE_SUCCESS';
export const ITINERARY_TRIP_THEMES_UPDATE_FAILURE = 'ITINERARY_TRIP_THEMES_UPDATE_FAILURE';

// Day Program
export const ITINERARY_DAY_PROGRAM_PENDING = 'ITINERARY_DAY_PROGRAM_PENDING';
export const ITINERARY_DAY_PROGRAM_SUCCESS = 'ITINERARY_DAY_PROGRAM_SUCCESS';
export const ITINERARY_DAY_PROGRAM_FAILURE = 'ITINERARY_DAY_PROGRAM_FAILURE';
export const ITINERARY_DAY_PROGRAM_PRICES_PENDING = 'ITINERARY_DAY_PROGRAM_PRICES_PENDING';
export const ITINERARY_DAY_PROGRAM_PRICES_SUCCESS = 'ITINERARY_DAY_PROGRAM_PRICES_SUCCESS';
export const ITINERARY_DAY_PROGRAM_PRICES_FAILURE = 'ITINERARY_DAY_PROGRAM_PRICES_FAILURE';
export const ITINERARY_DAY_PROGRAM_NO_CONTENT = 'ITINERARY_DAY_PROGRAM_NO_CONTENT';
export const ITINERARY_DAY_PROGRAM_PRICES_NO_CONTENT = 'ITINERARY_DAY_PROGRAM_PRICES_NO_CONTENT';
export const ITINERARY_DAY_PROGRAM_ADD_PENDING = 'ITINERARY_DAY_PROGRAM_ADD_PENDING';
export const ITINERARY_DAY_PROGRAM_ADD_SUCCESS = 'ITINERARY_DAY_PROGRAM_ADD_SUCCESS';
export const ITINERARY_DAY_PROGRAM_ADD_FAILURE = 'ITINERARY_DAY_PROGRAM_ADD_FAILURE';
export const ITINERARY_DAY_PROGRAM_DELETE_DAY_PENDING = 'ITINERARY_DAY_PROGRAM_DELETE_DAY_PENDING';
export const ITINERARY_DAY_PROGRAM_DELETE_DAY_SUCCESS = 'ITINERARY_DAY_PROGRAM_DELETE_DAY_SUCCESS';
export const ITINERARY_DAY_PROGRAM_DELETE_DAY_FAILURE = 'ITINERARY_DAY_PROGRAM_DELETE_DAY_FAILURE';
export const ITINERARY_DAY_PROGRAM_UPDATE_PENDING = 'ITINERARY_DAY_PROGRAM_UPDATE_PENDING';
export const ITINERARY_DAY_PROGRAM_UPDATE_SUCCESS = 'ITINERARY_DAY_PROGRAM_UPDATE_SUCCESS';
export const ITINERARY_DAY_PROGRAM_UPDATE_FAILURE = 'ITINERARY_DAY_PROGRAM_UPDATE_FAILURE';
export const ITINERARY_DAY_PROGRAM_LOCATION_SET = 'ITINERARY_DAY_PROGRAM_LOCATION_SET';
export const ITINERARY_DAY_PROGRAM_LOCATION_SAVE_PENDING = 'ITINERARY_DAY_PROGRAM_LOCATION_SAVE_PENDING';
export const ITINERARY_DAY_PROGRAM_LOCATION_SAVE_SUCCESS = 'ITINERARY_DAY_PROGRAM_LOCATION_SAVE_SUCCESS';
export const ITINERARY_DAY_PROGRAM_LOCATION_SAVE_FAILURE = 'ITINERARY_DAY_PROGRAM_LOCATION_SAVE_FAILURE';
export const ITINERARY_DAY_PROGRAM_LOCATION_UPDATE_DATA = 'ITINERARY_DAY_PROGRAM_LOCATION_UPDATE_DATA';
export const ITINERARY_DAY_PROGRAM_HOTEL_PENDING = 'ITINERARY_DAY_PROGRAM_HOTEL_PENDING';
export const ITINERARY_DAY_PROGRAM_HOTEL_CLEAR_LOADING = 'ITINERARY_DAY_PROGRAM_HOTEL_CLEAR_LOADING';
export const ITINERARY_DAY_PROGRAM_HOTEL_SET_LOADING = 'ITINERARY_DAY_PROGRAM_HOTEL_SET_LOADING';
export const ITINERARY_DAY_PROGRAM_SET_AVAILABLE_HOTELS = 'ITINERARY_DAY_PROGRAM_SET_AVAILABLE_HOTELS';
export const ITINERARY_DAY_PROGRAM_SET_SELECTED_HOTELS = 'ITINERARY_DAY_PROGRAM_SET_SELECTED_HOTELS';
export const ITINERARY_DAY_PROGRAM_HOTEL_UPDATE_SUCCESS = 'ITINERARY_DAY_PROGRAM_HOTEL_UPDATE_SUCCESS';
export const ITINERARY_DAY_PROGRAM_EXCURSIONS_PENDING = 'ITINERARY_DAY_PROGRAM_EXCURSIONS_PENDING';
export const ITINERARY_DAY_PROGRAM_EXCURSIONS_CLEAR_LOADING = 'ITINERARY_DAY_PROGRAM_EXCURSIONS_CLEAR_LOADING';
export const ITINERARY_DAY_PROGRAM_SET_AVAILABLE_EXCURSIONS = 'ITINERARY_DAY_PROGRAM_SET_AVAILABLE_EXCURSIONS';
export const ITINERARY_DAY_PROGRAM_EXCURSIONS_SET_LOADING = 'ITINERARY_DAY_PROGRAM_EXCURSIONS_SET_LOADING';
export const ITINERARY_DAY_PROGRAM_EXCURSIONS_UPDATE_SUCCESS = 'ITINERARY_DAY_PROGRAM_EXCURSIONS_UPDATE_SUCCESS';
export const ITINERARY_MEAL_PLAN_TYPES_PENDING = 'ITINERARY_MEAL_PLAN_TYPES_PENDING';
export const ITINERARY_MEAL_PLAN_TYPES_SUCCESS = 'ITINERARY_MEAL_PLAN_TYPES_SUCCESS';
export const ITINERARY_MEAL_PLAN_TYPES_FAILURE = 'ITINERARY_MEAL_PLAN_TYPES_FAILURE';
export const ITINERARY_DAY_PROGRAM_MEAL_PLANS_PENDING = 'ITINERARY_DAY_PROGRAM_MEAL_PLANS_PENDING';
export const ITINERARY_DAY_PROGRAM_MEAL_PLANS_SUCCESS = 'ITINERARY_DAY_PROGRAM_MEAL_PLANS_SUCCESS';
export const ITINERARY_DAY_PROGRAM_MEAL_PLANS_FAILURE = 'ITINERARY_DAY_PROGRAM_MEAL_PLANS_FAILURE';
export const ITINERARY_DAY_PROGRAM_MEAL_PLANS_SET_LOADING = 'ITINERARY_DAY_PROGRAM_MEAL_PLANS_SET_LOADING';
export const ITINERARY_DAY_PROGRAM_MEAL_PLANS_UPDATE_SUCCESS = 'ITINERARY_DAY_PROGRAM_MEAL_PLANS_UPDATE_SUCCESS';
export const ITINERARY_DAY_PROGRAM_MEAL_PLANS_CLEAR_LOADING = 'ITINERARY_DAY_PROGRAM_MEAL_PLANS_CLEAR_LOADING';
export const ITINERARY_INCLUDE_UPDATE_PENDING = 'ITINERARY_INCLUDE_UPDATE_PENDING';
export const ITINERARY_INCLUDE_UPDATE_SUCCESS = 'ITINERARY_INCLUDE_UPDATE_SUCCESS';
export const ITINERARY_INCLUDE_UPDATE_FAILURE = 'ITINERARY_INCLUDE_UPDATE_FAILURE';
export const ITINERARY_INCLUDE_PENDING = 'ITINERARY_INCLUDE_PENDING';
export const ITINERARY_INCLUDE_SUCCESS = 'ITINERARY_INCLUDE_SUCCESS';
export const ITINERARY_INCLUDE_NO_CONTENT = 'ITINERARY_INCLUDE_NO_CONTENT';
export const ITINERARY_INCLUDE_FAILURE = 'ITINERARY_INCLUDE_FAILURE';
export const ITINERARY_INCLUDE_CATEGORIES_PENDING = 'ITINERARY_INCLUDE_CATEGORIES_PENDING';
export const ITINERARY_INCLUDE_CATEGORIES_SUCCESS = 'ITINERARY_INCLUDE_CATEGORIES_SUCCESS';
export const ITINERARY_INCLUDE_CATEGORIES_FAILURE = 'ITINERARY_INCLUDE_CATEGORIES_FAILURE';
export const ITINERARY_TEASER_UPDATE_PENDING = 'ITINERARY_TEASER_UPDATE_PENDING';
export const ITINERARY_TEASER_UPDATE_SUCCESS = 'ITINERARY_TEASER_UPDATE_SUCCESS';
export const ITINERARY_TEASER_UPDATE_FAILURE = 'ITINERARY_TEASER_UPDATE_FAILURE';
export const ITINERARY_TEASER_PENDING = 'ITINERARY_TEASER_PENDING';
export const ITINERARY_TEASER_SUCCESS = 'ITINERARY_TEASER_SUCCESS';
export const ITINERARY_TEASER_FAILURE = 'ITINERARY_TEASER_FAILURE';
export const ITINERARY_DOMAINS_PENDING = 'ITINERARY_DOMAINS_PENDING';
export const ITINERARY_DOMAINS_SUCCESS = 'ITINERARY_DOMAINS_SUCCESS';
export const ITINERARY_DOMAINS_FAILURE = 'ITINERARY_DOMAINS_FAILURE';
export const ITINERARY_DOMAINS_NO_CONTENT = 'ITINERARY_DOMAINS_NO_CONTENT';
export const ITINERARY_DOMAIN_ADD_PENDING = 'ITINERARY_DOMAIN_ADD_PENDING';
export const ITINERARY_DOMAIN_ADD_SUCCESS = 'ITINERARY_DOMAIN_ADD_SUCCESS';
export const ITINERARY_DOMAIN_ADD_FAILURE = 'ITINERARY_DOMAIN_ADD_FAILURE';
export const ITINERARY_DOMAIN_UPDATE_PENDING = 'ITINERARY_DOMAIN_UPDATE_PENDING';
export const ITINERARY_DOMAIN_UPDATE_SUCCESS = 'ITINERARY_DOMAIN_UPDATE_SUCCESS';
export const ITINERARY_DOMAIN_UPDATE_FAILURE = 'ITINERARY_DOMAIN_UPDATE_FAILURE';

export const ITINERARY_DOMAIN_SELECT = 'ITINERARY_DOMAIN_SELECT';
export const ITINERARY_DOMAIN_DESELECT = 'ITINERARY_DOMAIN_DESELECT';

export const ITINERARY_DAY_PROGRAM_IMAGES_PENDING = 'ITINERARY_DAY_PROGRAM_IMAGES_PENDING';
export const ITINERARY_DAY_PROGRAM_IMAGES_SUCCESS = 'ITINERARY_DAY_PROGRAM_IMAGES_SUCCESS';
export const ITINERARY_DAY_PROGRAM_IMAGES_FAILURE = 'ITINERARY_DAY_PROGRAM_IMAGES_FAILURE';

export const ITINERARY_DAY_PROGRAM_IMAGES_SAVE_PENDING = 'ITINERARY_DAY_PROGRAM_IMAGES_SAVE_PENDING';
export const ITINERARY_DAY_PROGRAM_IMAGES_SAVE_SUCCESS = 'ITINERARY_DAY_PROGRAM_IMAGES_SAVE_SUCCESS';
export const ITINERARY_DAY_PROGRAM_IMAGES_SAVE_FAILURE = 'ITINERARY_DAY_PROGRAM_IMAGES_SAVE_FAILURE';

export const ITINERARY_BANNER_IMAGES_PENDING = 'ITINERARY_BANNER_IMAGES_PENDING';
export const ITINERARY_BANNER_IMAGES_SUCCESS = 'ITINERARY_BANNER_IMAGES_SUCCESS';
export const ITINERARY_BANNER_IMAGES_FAILURE = 'ITINERARY_BANNER_IMAGES_FAILURE';
export const ITINERARY_BANNER_IMAGES_SAVE_PENDING = 'ITINERARY_BANNER_IMAGES_SAVE_PENDING';
export const ITINERARY_BANNER_IMAGES_SAVE_SUCCESS = 'ITINERARY_BANNER_IMAGES_SAVE_SUCCESS';
export const ITINERARY_BANNER_IMAGES_SAVE_FAILURE = 'ITINERARY_BANNER_IMAGES_SAVE_FAILURE';
export const ITINERARY_BANNER_IMAGES_LOAD_PENDING = 'ITINERARY_BANNER_IMAGES_LOAD_PENDING';
export const ITINERARY_BANNER_IMAGES_LOAD_SUCCESS = 'ITINERARY_BANNER_IMAGES_LOAD_SUCCESS';
export const ITINERARY_BANNER_IMAGES_LOAD_FAILURE = 'ITINERARY_BANNER_IMAGES_LOAD_FAILURE';

export const ITINERARY_MAP_IMAGES_PENDING = 'ITINERARY_MAP_IMAGES_PENDING';
export const ITINERARY_MAP_IMAGES_SUCCESS = 'ITINERARY_MAP_IMAGES_SUCCESS';
export const ITINERARY_MAP_IMAGES_FAILURE = 'ITINERARY_MAP_IMAGES_FAILURE';
export const ITINERARY_MAP_IMAGES_SAVE_PENDING = 'ITINERARY_MAP_IMAGES_SAVE_PENDING';
export const ITINERARY_MAP_IMAGES_SAVE_SUCCESS = 'ITINERARY_MAP_IMAGES_SAVE_SUCCESS';
export const ITINERARY_MAP_IMAGES_SAVE_FAILURE = 'ITINERARY_MAP_IMAGES_SAVE_FAILURE';
export const ITINERARY_MAP_IMAGES_LOAD_PENDING = 'ITINERARY_MAP_IMAGES_LOAD_PENDING';
export const ITINERARY_MAP_IMAGES_LOAD_SUCCESS = 'ITINERARY_MAP_IMAGES_LOAD_SUCCESS';
export const ITINERARY_MAP_IMAGES_LOAD_FAILURE = 'ITINERARY_MAP_IMAGES_LOAD_FAILURE';

// Prices
export const ITINERARY_PRICE_INTERVAL_SYNC_PENDING = 'ITINERARY_PRICE_INTERVAL_SYNC_PENDING';
export const ITINERARY_PRICE_INTERVAL_SYNC_SUCCESS = 'ITINERARY_PRICE_INTERVAL_SYNC_SUCCESS';
export const ITINERARY_PRICE_INTERVAL_SYNC_FAILURE = 'ITINERARY_PRICE_INTERVAL_SYNC_FAILURE';

export const ITINERARY_PRICE_INTERVALS_GET_PENDING = 'ITINERARY_PRICE_INTERVALS_GET_PENDING';
export const ITINERARY_PRICE_INTERVALS_GET_SUCCESS = 'ITINERARY_PRICE_INTERVALS_GET_SUCCESS';
export const ITINERARY_PRICE_INTERVALS_GET_NO_CONTENT = 'ITINERARY_PRICE_INTERVALS_GET_NO_CONTENT';
export const ITINERARY_PRICE_INTERVALS_GET_FAILURE = 'ITINERARY_PRICE_INTERVALS_GET_FAILURE';

export const ITINERARY_PRICE_SETTINGS_SYNC_PENDING = 'ITINERARY_PRICE_SETTINGS_SYNC_PENDING';
export const ITINERARY_PRICE_SETTINGS_SYNC_SUCCESS = 'ITINERARY_PRICE_SETTINGS_SYNC_SUCCESS';
export const ITINERARY_PRICE_SETTINGS_SYNC_FAILURE = 'ITINERARY_PRICE_SETTINGS_SYNC_FAILURE';

export const ITINERARY_PRICE_SETTINGS_GET_PENDING = 'ITINERARY_PRICE_SETTINGS_GET_PENDING';
export const ITINERARY_PRICE_SETTINGS_GET_SUCCESS =  'ITINERARY_PRICE_SETTINGS_GET_SUCCESS';
export const ITINERARY_PRICE_SETTINGS_GET_NO_CONTENT = 'ITINERARY_PRICE_SETTINGS_GET_NO_CONTENT';
export const ITINERARY_PRICE_SETTINGS_GET_FAILURE = 'ITINERARY_PRICE_SETTINGS_GET_FAILURE';

export const ITINERARY_PRICE_SETTINGS_COPY_PENDING = 'ITINERARY_PRICE_SETTINGS_COPY_PENDING';
export const ITINERARY_PRICE_SETTINGS_COPY_SUCCESS = 'ITINERARY_PRICE_SETTINGS_COPY_SUCCESS';
export const ITINERARY_PRICE_SETTINGS_COPY_FAILURE = 'ITINERARY_PRICE_SETTINGS_COPY_FAILURE';

export const ITINERARY_CLONE_PENDING = 'ITINERARY_CLONE_PENDING';
export const ITINERARY_CLONE_SUCCESS = 'ITINERARY_CLONE_SUCCESS';
export const ITINERARY_CLONE_FAILURE = 'ITINERARY_CLONE_FAILURE';

/*
  -----------------

  Ski

  -----------------
 */

export const SKI_PASS_RESET_STATE = 'SKI_PASS_RESET_STATE';
export const SKI_SCHOOL_RESET_STATE = 'SKI_SCHOOL_RESET_STATE';
export const SKI_RENTAL_RESET_STATE = 'SKI_RENTAL_RESET_STATE';

// Ski pass season
export const SKI_PASS_SEASONS_LOAD_PENDING = 'SKI_PASS_SEASONS_LOAD_PENDING';
export const SKI_PASS_SEASONS_LOAD_SUCCESS = 'SKI_PASS_SEASONS_LOAD_SUCCESS';
export const SKI_PASS_SEASONS_LOAD_FAILURE = 'SKI_PASS_SEASONS_LOAD_FAILURE';
export const SKI_PASS_SEASON_LOAD_PENDING = 'SKI_PASS_SEASON_LOAD_PENDING';
export const SKI_PASS_SEASON_LOAD_SUCCESS = 'SKI_PASS_SEASON_LOAD_SUCCESS';
export const SKI_PASS_SEASON_LOAD_FAILURE = 'SKI_PASS_SEASON_LOAD_FAILURE';
export const SKI_PASS_SEASON_SET = 'SKI_PASS_SEASON_SET';
export const SKI_PASS_SEASON_CREATE_PENDING = 'SKI_PASS_SEASON_CREATE_PENDING';
export const SKI_PASS_SEASON_CREATE_SUCCESS = 'SKI_PASS_SEASON_CREATE_SUCCESS';
export const SKI_PASS_SEASON_CREATE_FAILURE = 'SKI_PASS_SEASON_CREATE_FAILURE';
export const SKI_PASS_SEASON_SAVE_PENDING = 'SKI_PASS_SEASON_SAVE_PENDING';
export const SKI_PASS_SEASON_SAVE_SUCCESS = 'SKI_PASS_SEASON_SAVE_SUCCESS';
export const SKI_PASS_SEASON_SAVE_FAILURE = 'SKI_PASS_SEASON_SAVE_FAILURE';

export const SKI_PASS_SEASON_PICK_UP_PLACES_PENDING= 'SKI_PASS_SEASON_PICK_UP_PLACES_PENDING';
export const SKI_PASS_SEASON_PICK_UP_PLACES_SUCCESS = 'SKI_PASS_SEASON_PICK_UP_PLACES_SUCCESS';
export const SKI_PASS_SEASON_PICK_UP_PLACES_FAILURE = 'SKI_PASS_SEASON_PICK_UP_PLACES_FAILURE';

// Ski pass season sales types
export const SKI_PASS_SALES_TYPES_LOAD_PENDING = 'SKI_PASS_SALES_TYPES_LOAD_PENDING';
export const SKI_PASS_SALES_TYPES_LOAD_SUCCESS = 'SKI_PASS_SALES_TYPES_LOAD_SUCCESS';
export const SKI_PASS_SALES_TYPES_LOAD_FAILURE = 'SKI_PASS_SALES_TYPES_LOAD_FAILURE';

// Ski pass person Categories
export const SKI_PASS_PERSON_CATEGORIES_SET = 'SKI_PASS_PERSON_CATEGORIES_SET';
export const SKI_PASS_PERSON_CATEGORIES_LOAD_PENDING = 'SKI_PASS_PERSON_CATEGORIES_LOAD_PENDING';
export const SKI_PASS_PERSON_CATEGORIES_LOAD_SUCCESS = 'SKI_PASS_PERSON_CATEGORIES_LOAD_SUCCESS';
export const SKI_PASS_PERSON_CATEGORIES_LOAD_FAILURE = 'SKI_PASS_PERSON_CATEGORIES_LOAD_FAILURE';
export const SKI_PASS_PERSON_CATEGORY_ADD = 'SKI_PASS_PERSON_CATEGORY_ADD';
export const SKI_PASS_PERSON_CATEGORY_CREATE_PENDING = 'SKI_PASS_PERSON_CATEGORY_CREATE_PENDING';
export const SKI_PASS_PERSON_CATEGORY_CREATE_SUCCESS = 'SKI_PASS_PERSON_CATEGORY_CREATE_SUCCESS';
export const SKI_PASS_PERSON_CATEGORY_CREATE_FAILURE = 'SKI_PASS_PERSON_CATEGORY_CREATE_FAILURE';
export const SKI_PASS_PERSON_CATEGORY_SAVE_PENDING = 'SKI_PASS_PERSON_CATEGORY_SAVE_PENDING';
export const SKI_PASS_PERSON_CATEGORY_SAVE_SUCCESS = 'SKI_PASS_PERSON_CATEGORY_SAVE_SUCCESS';
export const SKI_PASS_PERSON_CATEGORY_SAVE_FAILURE = 'SKI_PASS_PERSON_CATEGORY_SAVE_FAILURE';
export const SKI_PASS_PERSON_CATEGORY_REMOVE_PENDING = 'SKI_PASS_PERSON_CATEGORY_REMOVE_PENDING';
export const SKI_PASS_PERSON_CATEGORY_REMOVE_SUCCESS = 'SKI_PASS_PERSON_CATEGORY_REMOVE_SUCCESS';
export const SKI_PASS_PERSON_CATEGORY_REMOVE_FAILURE = 'SKI_PASS_PERSON_CATEGORY_REMOVE_FAILURE';

// Ski pass discounts
export const SKI_PASS_DISCOUNT_SET = 'SKI_PASS_DISCOUNT_SET';
export const SKI_PASS_DISCOUNTS_LOAD_PENDING = 'SKI_PASS_DISCOUNTS_LOAD_PENDING';
export const SKI_PASS_DISCOUNTS_LOAD_SUCCESS = 'SKI_PASS_DISCOUNTS_LOAD_SUCCESS';
export const SKI_PASS_DISCOUNTS_LOAD_FAILURE = 'SKI_PASS_DISCOUNTS_LOAD_FAILURE';
export const SKI_PASS_DISCOUNT_ADD = 'SKI_PASS_DISCOUNT_ADD';
export const SKI_PASS_DISCOUNT_CREATE_PENDING = 'SKI_PASS_DISCOUNT_CREATE_PENDING';
export const SKI_PASS_DISCOUNT_CREATE_SUCCESS = 'SKI_PASS_DISCOUNT_CREATE_SUCCESS';
export const SKI_PASS_DISCOUNT_CREATE_FAILURE = 'SKI_PASS_DISCOUNT_CREATE_FAILURE';
export const SKI_PASS_DISCOUNT_SAVE_PENDING = 'SKI_PASS_DISCOUNT_SAVE_PENDING';
export const SKI_PASS_DISCOUNT_SAVE_SUCCESS = 'SKI_PASS_DISCOUNT_SAVE_SUCCESS';
export const SKI_PASS_DISCOUNT_SAVE_FAILURE = 'SKI_PASS_DISCOUNT_SAVE_FAILURE';
export const SKI_PASS_DISCOUNT_REMOVE_PENDING = 'SKI_PASS_DISCOUNT_REMOVE_PENDING';
export const SKI_PASS_DISCOUNT_REMOVE_SUCCESS = 'SKI_PASS_DISCOUNT_REMOVE_SUCCESS';
export const SKI_PASS_DISCOUNT_REMOVE_FAILURE = 'SKI_PASS_DISCOUNT_REMOVE_FAILURE';

// Ski pass discount person category
export const SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_PENDING = 'SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_PENDING';
export const SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_SUCCESS = 'SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_SUCCESS';
export const SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_FAILURE = 'SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_FAILURE';
export const SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_PENDING = 'SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_PENDING';
export const SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_SUCCESS = 'SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_SUCCESS';
export const SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_FAILURE = 'SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_FAILURE';

// Ski pass periods periods
export const SKI_PASS_PERIODS_LOAD_PENDING = 'SKI_PASS_PERIODS_LOAD_PENDING';
export const SKI_PASS_PERIODS_LOAD_SUCCESS = 'SKI_PASS_PERIODS_LOAD_SUCCESS';
export const SKI_PASS_PERIODS_LOAD_FAILURE = 'SKI_PASS_PERIODS_LOAD_FAILURE';
export const SKI_PASS_PERIOD_ADD = 'SKI_PASS_PERIOD_ADD';
export const SKI_PASS_PERIOD_SET = 'SKI_PASS_PERIOD_SET';
export const SKI_PASS_PERIOD_CREATE_PENDING = 'SKI_PASS_PERIOD_CREATE_PENDING';
export const SKI_PASS_PERIOD_CREATE_SUCCESS = 'SKI_PASS_PERIOD_CREATE_SUCCESS';
export const SKI_PASS_PERIOD_CREATE_FAILURE = 'SKI_PASS_PERIOD_CREATE_FAILURE';
export const SKI_PASS_PERIOD_SAVE_PENDING = 'SKI_PASS_PERIOD_SAVE_PENDING';
export const SKI_PASS_PERIOD_SAVE_SUCCESS = 'SKI_PASS_PERIOD_SAVE_SUCCESS';
export const SKI_PASS_PERIOD_SAVE_FAILURE = 'SKI_PASS_PERIOD_SAVE_FAILURE';
export const SKI_PASS_PERIOD_REMOVE_PENDING = 'SKI_PASS_PERIOD_REMOVE_PENDING';
export const SKI_PASS_PERIOD_REMOVE_SUCCESS = 'SKI_PASS_PERIOD_REMOVE_SUCCESS';
export const SKI_PASS_PERIOD_REMOVE_FAILURE = 'SKI_PASS_PERIOD_REMOVE_FAILURE';

// Ski pass prices
export const SKI_PASS_PERIOD_PRICE_SET = 'SKI_PASS_PERIOD_PRICE_SET';
export const SKI_PASS_PERIOD_PRICE_LOAD_PENDING = 'SKI_PASS_PERIOD_PRICE_LOAD_PENDING';
export const SKI_PASS_PERIOD_PRICE_LOAD_SUCCESS = 'SKI_PASS_PERIOD_PRICE_LOAD_SUCCESS';
export const SKI_PASS_PERIOD_PRICE_LOAD_FAILURE = 'SKI_PASS_PERIOD_PRICE_LOAD_FAILURE';
export const SKI_PASS_PERIOD_PRICE_ADD = 'SKI_PASS_PERIOD_PRICE_ADD';
export const SKI_PASS_PERIOD_PRICE_CREATE_PENDING = 'SKI_PASS_PERIOD_PRICE_CREATE_PENDING';
export const SKI_PASS_PERIOD_PRICE_CREATE_SUCCESS = 'SKI_PASS_PERIOD_PRICE_CREATE_SUCCESS';
export const SKI_PASS_PERIOD_PRICE_CREATE_FAILURE = 'SKI_PASS_PERIOD_PRICE_CREATE_FAILURE';
export const SKI_PASS_PERIOD_PRICE_SAVE_PENDING = 'SKI_PASS_PERIOD_PRICE_SAVE_PENDING';
export const SKI_PASS_PERIOD_PRICE_SAVE_SUCCESS = 'SKI_PASS_PERIOD_PRICE_SAVE_SUCCESS';
export const SKI_PASS_PERIOD_PRICE_SAVE_FAILURE = 'SKI_PASS_PERIOD_PRICE_SAVE_FAILURE';
export const SKI_PASS_PERIOD_PRICE_REMOVE_PENDING = 'SKI_PASS_PERIOD_PRICE_REMOVE_PENDING';
export const SKI_PASS_PERIOD_PRICE_REMOVE_SUCCESS = 'SKI_PASS_PERIOD_PRICE_REMOVE_SUCCESS';
export const SKI_PASS_PERIOD_PRICE_REMOVE_FAILURE = 'SKI_PASS_PERIOD_PRICE_REMOVE_FAILURE';

// Suppliers for price settings
export const SKI_SUPPLIERS_LOAD_PENDING = 'SKI_SUPPLIERS_LOAD_PENDING';
export const SKI_SUPPLIERS_LOAD_SUCCESS = 'SKI_SUPPLIERS_LOAD_SUCCESS';
export const SKI_SUPPLIERS_LOAD_FAILURE = 'SKI_SUPPLIERS_LOAD_FAILURE';

// Ski pass areas
export const SKI_PASS_AREAS_LOAD_PENDING = 'SKI_PASS_AREAS_LOAD_PENDING';
export const SKI_PASS_AREAS_LOAD_SUCCESS = 'SKI_PASS_AREAS_LOAD_SUCCESS';
export const SKI_PASS_AREAS_LOAD_FAILURE = 'SKI_PASS_AREAS_LOAD_FAILURE';
export const SKI_PASS_AREAS_SAVE_PENDING = 'SKI_PASS_AREAS_SAVE_PENDING';
export const SKI_PASS_AREAS_SAVE_SUCCESS = 'SKI_PASS_AREAS_SAVE_SUCCESS';
export const SKI_PASS_AREAS_SAVE_FAILURE = 'SKI_PASS_AREAS_SAVE_FAILURE';
export const SKI_PASS_AREAS_DELETE_PENDING = 'SKI_PASS_AREAS_DELETE_PENDING';
export const SKI_PASS_AREAS_DELETE_SUCCESS = 'SKI_PASS_AREAS_DELETE_SUCCESS';
export const SKI_PASS_AREAS_DELETE_FAILURE = 'SKI_PASS_AREAS_DELETE_FAILURE';

// Ski area pickup places
export const SKI_PICKUP_PLACES_GET_PENDING = 'SKI_PICKUP_PLACES_GET_PENDING';
export const SKI_PICKUP_PLACES_GET_SUCCESS = 'SKI_PICKUP_PLACES_GET_SUCCESS';
export const SKI_PICKUP_PLACES_GET_FAILURE = 'SKI_PICKUP_PLACES_GET_FAILURE';
export const SKI_PICKUP_PLACES_UPDATE_PENDING = 'SKI_PICKUP_PLACES_UPDATE_PENDING';
export const SKI_PICKUP_PLACES_UPDATE_SUCCESS = 'SKI_PICKUP_PLACES_UPDATE_SUCCESS';
export const SKI_PICKUP_PLACES_UPDATE_FAILURE = 'SKI_PICKUP_PLACES_UPDATE_FAILURE';

// Ski school season
export const SKI_SCHOOL_SEASONS_LOAD_PENDING = 'SKI_SCHOOL_SEASONS_LOAD_PENDING';
export const SKI_SCHOOL_SEASONS_LOAD_SUCCESS = 'SKI_SCHOOL_SEASONS_LOAD_SUCCESS';
export const SKI_SCHOOL_SEASONS_LOAD_FAILURE = 'SKI_SCHOOL_SEASONS_LOAD_FAILURE';
export const SKI_SCHOOL_SEASON_LOAD_PENDING = 'SKI_SCHOOL_SEASON_LOAD_PENDING';
export const SKI_SCHOOL_SEASON_LOAD_SUCCESS = 'SKI_SCHOOL_SEASON_LOAD_SUCCESS';
export const SKI_SCHOOL_SEASON_LOAD_FAILURE = 'SKI_SCHOOL_SEASON_LOAD_FAILURE';
export const SKI_SCHOOL_SEASON_SET = 'SKI_SCHOOL_SEASON_SET';
export const SKI_SCHOOL_SEASON_CREATE_PENDING = 'SKI_SCHOOL_SEASON_CREATE_PENDING';
export const SKI_SCHOOL_SEASON_CREATE_SUCCESS = 'SKI_SCHOOL_SEASON_CREATE_SUCCESS';
export const SKI_SCHOOL_SEASON_CREATE_FAILURE = 'SKI_SCHOOL_SEASON_CREATE_FAILURE';
export const SKI_SCHOOL_SEASON_SAVE_PENDING = 'SKI_SCHOOL_SEASON_SAVE_PENDING';
export const SKI_SCHOOL_SEASON_SAVE_SUCCESS = 'SKI_SCHOOL_SEASON_SAVE_SUCCESS';
export const SKI_SCHOOL_SEASON_SAVE_FAILURE = 'SKI_SCHOOL_SEASON_SAVE_FAILURE';

// Ski school person categories
export const SKI_SCHOOL_PERSON_CATEGORIES_SET = 'SKI_SCHOOL_PERSON_CATEGORIES_SET';
export const SKI_SCHOOL_PERSON_CATEGORIES_LOAD_PENDING = 'SKI_SCHOOL_PERSON_CATEGORIES_LOAD_PENDING';
export const SKI_SCHOOL_PERSON_CATEGORIES_LOAD_SUCCESS = 'SKI_SCHOOL_PERSON_CATEGORIES_LOAD_SUCCESS';
export const SKI_SCHOOL_PERSON_CATEGORIES_LOAD_FAILURE = 'SKI_SCHOOL_PERSON_CATEGORIES_LOAD_FAILURE';
export const SKI_SCHOOL_PERSON_CATEGORY_ADD = 'SKI_SCHOOL_PERSON_CATEGORY_ADD';
export const SKI_SCHOOL_PERSON_CATEGORY_CREATE_PENDING = 'SKI_SCHOOL_PERSON_CATEGORY_CREATE_PENDING';
export const SKI_SCHOOL_PERSON_CATEGORY_CREATE_SUCCESS = 'SKI_SCHOOL_PERSON_CATEGORY_CREATE_SUCCESS';
export const SKI_SCHOOL_PERSON_CATEGORY_CREATE_FAILURE = 'SKI_SCHOOL_PERSON_CATEGORY_CREATE_FAILURE';
export const SKI_SCHOOL_PERSON_CATEGORY_SAVE_PENDING = 'SKI_SCHOOL_PERSON_CATEGORY_SAVE_PENDING';
export const SKI_SCHOOL_PERSON_CATEGORY_SAVE_SUCCESS = 'SKI_SCHOOL_PERSON_CATEGORY_SAVE_SUCCESS';
export const SKI_SCHOOL_PERSON_CATEGORY_SAVE_FAILURE = 'SKI_SCHOOL_PERSON_CATEGORY_SAVE_FAILURE';
export const SKI_SCHOOL_PERSON_CATEGORY_REMOVE_PENDING = 'SKI_SCHOOL_PERSON_CATEGORY_REMOVE_PENDING';
export const SKI_SCHOOL_PERSON_CATEGORY_REMOVE_SUCCESS = 'SKI_SCHOOL_PERSON_CATEGORY_REMOVE_SUCCESS';
export const SKI_SCHOOL_PERSON_CATEGORY_REMOVE_FAILURE = 'SKI_SCHOOL_PERSON_CATEGORY_REMOVE_FAILURE';

// Ski school levels
export const SKI_SCHOOL_LEVELS_SET = 'SKI_SCHOOL_LEVELS_SET';
export const SKI_SCHOOL_LEVELS_LOAD_PENDING = 'SKI_SCHOOL_LEVELS_LOAD_PENDING';
export const SKI_SCHOOL_LEVELS_LOAD_SUCCESS = 'SKI_SCHOOL_LEVELS_LOAD_SUCCESS';
export const SKI_SCHOOL_LEVELS_LOAD_FAILURE = 'SKI_SCHOOL_LEVELS_LOAD_FAILURE';
export const SKI_SCHOOL_LEVEL_ADD = 'SKI_SCHOOL_LEVEL_ADD';
export const SKI_SCHOOL_LEVEL_CREATE_PENDING = 'SKI_SCHOOL_LEVEL_CREATE_PENDING';
export const SKI_SCHOOL_LEVEL_CREATE_SUCCESS = 'SKI_SCHOOL_LEVEL_CREATE_SUCCESS';
export const SKI_SCHOOL_LEVEL_CREATE_FAILURE = 'SKI_SCHOOL_LEVEL_CREATE_FAILURE';
export const SKI_SCHOOL_LEVEL_SAVE_PENDING = 'SKI_SCHOOL_LEVEL_SAVE_PENDING';
export const SKI_SCHOOL_LEVEL_SAVE_SUCCESS = 'SKI_SCHOOL_LEVEL_SAVE_SUCCESS';
export const SKI_SCHOOL_LEVEL_SAVE_FAILURE = 'SKI_SCHOOL_LEVEL_SAVE_FAILURE';
export const SKI_SCHOOL_LEVEL_REMOVE_PENDING = 'SKI_SCHOOL_LEVEL_REMOVE_PENDING';
export const SKI_SCHOOL_LEVEL_REMOVE_SUCCESS = 'SKI_SCHOOL_LEVEL_REMOVE_SUCCESS';
export const SKI_SCHOOL_LEVEL_REMOVE_FAILURE = 'SKI_SCHOOL_LEVEL_REMOVE_FAILURE';

// Ski school season sales types
export const SKI_SCHOOL_SALES_TYPES_LOAD_PENDING = 'SKI_SCHOOL_SALES_TYPES_LOAD_PENDING';
export const SKI_SCHOOL_SALES_TYPES_LOAD_SUCCESS = 'SKI_SCHOOL_SALES_TYPES_LOAD_SUCCESS';
export const SKI_SCHOOL_SALES_TYPES_LOAD_FAILURE = 'SKI_SCHOOL_SALES_TYPES_LOAD_FAILURE';

// Ski school lesson types
export const SKI_SCHOOL_LESSON_TYPES_LOAD_PENDING = 'SKI_SCHOOL_LESSON_TYPES_LOAD_PENDING';
export const SKI_SCHOOL_LESSON_TYPES_LOAD_SUCCESS = 'SKI_SCHOOL_LESSON_TYPES_LOAD_SUCCESS';
export const SKI_SCHOOL_LESSON_TYPES_LOAD_FAILURE = 'SKI_SCHOOL_LESSON_TYPES_LOAD_FAILURE';

// Ski school ski types
export const SKI_SCHOOL_SKI_TYPES_LOAD_PENDING = 'SKI_SCHOOL_SKI_TYPES_LOAD_PENDING';
export const SKI_SCHOOL_SKI_TYPES_LOAD_SUCCESS = 'SKI_SCHOOL_SKI_TYPES_LOAD_SUCCESS';
export const SKI_SCHOOL_SKI_TYPES_LOAD_FAILURE = 'SKI_SCHOOL_SKI_TYPES_LOAD_FAILURE';

// Ski school prices
export const SKI_SCHOOL_PRICE_SET = 'SKI_SCHOOL_PRICE_SET';
export const SKI_SCHOOL_PRICE_ADD = 'SKI_SCHOOL_PRICE_ADD';
export const SKI_SCHOOL_PRICES_LOAD_PENDING = 'SKI_SCHOOL_PRICES_LOAD_PENDING';
export const SKI_SCHOOL_PRICES_LOAD_SUCCESS = 'SKI_SCHOOL_PRICES_LOAD_SUCCESS';
export const SKI_SCHOOL_PRICES_LOAD_FAILURE = 'SKI_SCHOOL_PRICES_LOAD_FAILURE';
export const SKI_SCHOOL_PRICE_CREATE_PENDING = 'SKI_SCHOOL_PRICE_CREATE_PENDING';
export const SKI_SCHOOL_PRICE_CREATE_SUCCESS = 'SKI_SCHOOL_PRICE_CREATE_SUCCESS';
export const SKI_SCHOOL_PRICE_CREATE_FAILURE = 'SKI_SCHOOL_PRICE_CREATE_FAILURE';
export const SKI_SCHOOL_PRICE_SAVE_PENDING = 'SKI_SCHOOL_PRICE_SAVE_PENDING';
export const SKI_SCHOOL_PRICE_SAVE_SUCCESS = 'SKI_SCHOOL_PRICE_SAVE_SUCCESS';
export const SKI_SCHOOL_PRICE_SAVE_FAILURE = 'SKI_SCHOOL_PRICE_SAVE_FAILURE';
export const SKI_SCHOOL_PRICE_REMOVE_PENDING = 'SKI_SCHOOL_PRICE_REMOVE_PENDING';
export const SKI_SCHOOL_PRICE_REMOVE_SUCCESS = 'SKI_SCHOOL_PRICE_REMOVE_SUCCESS';
export const SKI_SCHOOL_PRICE_REMOVE_FAILURE = 'SKI_SCHOOL_PRICE_REMOVE_FAILURE';

// Ski school price start days
export const SKI_SCHOOL_PRICE_START_DAY_SAVE_PENDING = 'SKI_SCHOOL_PRICE_START_DAY_SAVE_PENDING';
export const SKI_SCHOOL_PRICE_START_DAY_SAVE_SUCCESS = 'SKI_SCHOOL_PRICE_START_DAY_SAVE_SUCCESS';
export const SKI_SCHOOL_PRICE_START_DAY_SAVE_FAILURE = 'SKI_SCHOOL_PRICE_START_DAY_SAVE_FAILURE';
export const SKI_SCHOOL_PRICE_START_DAY_DELETE_PENDING = 'SKI_SCHOOL_PRICE_START_DAY_DELETE_PENDING';
export const SKI_SCHOOL_PRICE_START_DAY_DELETE_SUCCESS = 'SKI_SCHOOL_PRICE_START_DAY_DELETE_SUCCESS';
export const SKI_SCHOOL_PRICE_START_DAY_DELETE_FAILURE = 'SKI_SCHOOL_PRICE_START_DAY_DELETE_FAILURE';

// Ski school price combinations
export const SKI_SCHOOL_PRICE_COMBINATION_SAVE_PENDING = 'SKI_SCHOOL_PRICE_COMBINATION_SAVE_PENDING';
export const SKI_SCHOOL_PRICE_COMBINATION_SAVE_SUCCESS = 'SKI_SCHOOL_PRICE_COMBINATION_SAVE_SUCCESS';
export const SKI_SCHOOL_PRICE_COMBINATION_SAVE_FAILURE = 'SKI_SCHOOL_PRICE_COMBINATION_SAVE_FAILURE';
export const SKI_SCHOOL_PRICE_COMBINATION_DELETE_PENDING = 'SKI_SCHOOL_PRICE_COMBINATION_DELETE_PENDING';
export const SKI_SCHOOL_PRICE_COMBINATION_DELETE_SUCCESS = 'SKI_SCHOOL_PRICE_COMBINATION_DELETE_SUCCESS';
export const SKI_SCHOOL_PRICE_COMBINATION_DELETE_FAILURE = 'SKI_SCHOOL_PRICE_COMBINATION_DELETE_FAILURE';

// Ski school areas
export const SKI_SCHOOL_AREAS_LOAD_PENDING = 'SKI_SCHOOL_AREAS_LOAD_PENDING';
export const SKI_SCHOOL_AREAS_LOAD_SUCCESS = 'SKI_SCHOOL_AREAS_LOAD_SUCCESS';
export const SKI_SCHOOL_AREAS_LOAD_FAILURE = 'SKI_SCHOOL_AREAS_LOAD_FAILURE';
export const SKI_SCHOOL_AREAS_SAVE_PENDING = 'SKI_SCHOOL_AREAS_SAVE_PENDING';
export const SKI_SCHOOL_AREAS_SAVE_SUCCESS = 'SKI_SCHOOL_AREAS_SAVE_SUCCESS';
export const SKI_SCHOOL_AREAS_SAVE_FAILURE = 'SKI_SCHOOL_AREAS_SAVE_FAILURE';
export const SKI_SCHOOL_AREAS_DELETE_PENDING = 'SKI_SCHOOL_AREAS_DELETE_PENDING';
export const SKI_SCHOOL_AREAS_DELETE_SUCCESS = 'SKI_SCHOOL_AREAS_DELETE_SUCCESS';
export const SKI_SCHOOL_AREAS_DELETE_FAILURE = 'SKI_SCHOOL_AREAS_DELETE_FAILURE';

// Ski rental season
export const SKI_RENTAL_SEASONS_LOAD_PENDING = 'SKI_RENTAL_SEASONS_LOAD_PENDING';
export const SKI_RENTAL_SEASONS_LOAD_SUCCESS = 'SKI_RENTAL_SEASONS_LOAD_SUCCESS';
export const SKI_RENTAL_SEASONS_LOAD_FAILURE = 'SKI_RENTAL_SEASONS_LOAD_FAILURE';
export const SKI_RENTAL_SEASON_LOAD_PENDING = 'SKI_RENTAL_SEASON_LOAD_PENDING';
export const SKI_RENTAL_SEASON_LOAD_SUCCESS = 'SKI_RENTAL_SEASON_LOAD_SUCCESS';
export const SKI_RENTAL_SEASON_LOAD_FAILURE = 'SKI_RENTAL_SEASON_LOAD_FAILURE';
export const SKI_RENTAL_SEASON_SET = 'SKI_RENTAL_SEASON_SET';
export const SKI_RENTAL_SEASON_CREATE_PENDING = 'SKI_RENTAL_SEASON_CREATE_PENDING';
export const SKI_RENTAL_SEASON_CREATE_SUCCESS = 'SKI_RENTAL_SEASON_CREATE_SUCCESS';
export const SKI_RENTAL_SEASON_CREATE_FAILURE = 'SKI_RENTAL_SEASON_CREATE_FAILURE';
export const SKI_RENTAL_SEASON_SAVE_PENDING = 'SKI_RENTAL_SEASON_SAVE_PENDING';
export const SKI_RENTAL_SEASON_SAVE_SUCCESS = 'SKI_RENTAL_SEASON_SAVE_SUCCESS';
export const SKI_RENTAL_SEASON_SAVE_FAILURE = 'SKI_RENTAL_SEASON_SAVE_FAILURE';

// Ski rental season period dates
export const SKI_RENTAL_PERIOD_DATES_LOAD_PENDING = 'SKI_RENTAL_PERIOD_DATES_LOAD_PENDING';
export const SKI_RENTAL_PERIOD_DATES_LOAD_SUCCESS = 'SKI_RENTAL_PERIOD_DATES_LOAD_SUCCESS';
export const SKI_RENTAL_PERIOD_DATES_LOAD_FAILURE = 'SKI_RENTAL_PERIOD_DATES_LOAD_FAILURE';
export const SKI_RENTAL_PERIOD_DATES_SET = 'SKI_RENTAL_PERIOD_DATES_SET';
export const SKI_RENTAL_PERIOD_DATE_ADD = 'SKI_RENTAL_PERIOD_DATE_ADD';
export const SKI_RENTAL_PERIOD_DATE_CREATE_PENDING = 'SKI_RENTAL_PERIOD_DATE_CREATE_PENDING';
export const SKI_RENTAL_PERIOD_DATE_CREATE_SUCCESS = 'SKI_RENTAL_PERIOD_DATE_CREATE_SUCCESS';
export const SKI_RENTAL_PERIOD_DATE_CREATE_FAILURE = 'SKI_RENTAL_PERIOD_DATE_CREATE_FAILURE';
export const SKI_RENTAL_PERIOD_DATE_DELETE_PENDING = 'SKI_RENTAL_PERIOD_DATE_DELETE_PENDING';
export const SKI_RENTAL_PERIOD_DATE_DELETE_SUCCESS = 'SKI_RENTAL_PERIOD_DATE_DELETE_SUCCESS';
export const SKI_RENTAL_PERIOD_DATE_DELETE_FAILURE = 'SKI_RENTAL_PERIOD_DATE_DELETE_FAILURE';

// Ski rental person Categories
export const SKI_RENTAL_PERSON_CATEGORIES_SET = 'SKI_RENTAL_PERSON_CATEGORIES_SET';
export const SKI_RENTAL_PERSON_CATEGORIES_LOAD_PENDING = 'SKI_RENTAL_PERSON_CATEGORIES_LOAD_PENDING';
export const SKI_RENTAL_PERSON_CATEGORIES_LOAD_SUCCESS = 'SKI_RENTAL_PERSON_CATEGORIES_LOAD_SUCCESS';
export const SKI_RENTAL_PERSON_CATEGORIES_LOAD_FAILURE = 'SKI_RENTAL_PERSON_CATEGORIES_LOAD_FAILURE';
export const SKI_RENTAL_PERSON_CATEGORY_ADD = 'SKI_RENTAL_PERSON_CATEGORY_ADD';
export const SKI_RENTAL_PERSON_CATEGORY_CREATE_PENDING = 'SKI_RENTAL_PERSON_CATEGORY_CREATE_PENDING';
export const SKI_RENTAL_PERSON_CATEGORY_CREATE_SUCCESS = 'SKI_RENTAL_PERSON_CATEGORY_CREATE_SUCCESS';
export const SKI_RENTAL_PERSON_CATEGORY_CREATE_FAILURE = 'SKI_RENTAL_PERSON_CATEGORY_CREATE_FAILURE';
export const SKI_RENTAL_PERSON_CATEGORY_SAVE_PENDING = 'SKI_RENTAL_PERSON_CATEGORY_SAVE_PENDING';
export const SKI_RENTAL_PERSON_CATEGORY_SAVE_SUCCESS = 'SKI_RENTAL_PERSON_CATEGORY_SAVE_SUCCESS';
export const SKI_RENTAL_PERSON_CATEGORY_SAVE_FAILURE = 'SKI_RENTAL_PERSON_CATEGORY_SAVE_FAILURE';
export const SKI_RENTAL_PERSON_CATEGORY_REMOVE_PENDING = 'SKI_RENTAL_PERSON_CATEGORY_REMOVE_PENDING';
export const SKI_RENTAL_PERSON_CATEGORY_REMOVE_SUCCESS = 'SKI_RENTAL_PERSON_CATEGORY_REMOVE_SUCCESS';
export const SKI_RENTAL_PERSON_CATEGORY_REMOVE_FAILURE = 'SKI_RENTAL_PERSON_CATEGORY_REMOVE_FAILURE';

// Ski rental discounts
export const SKI_RENTAL_DISCOUNT_SET = 'SKI_RENTAL_DISCOUNT_SET';
export const SKI_RENTAL_DISCOUNTS_LOAD_PENDING = 'SKI_RENTAL_DISCOUNTS_LOAD_PENDING';
export const SKI_RENTAL_DISCOUNTS_LOAD_SUCCESS = 'SKI_RENTAL_DISCOUNTS_LOAD_SUCCESS';
export const SKI_RENTAL_DISCOUNTS_LOAD_FAILURE = 'SKI_RENTAL_DISCOUNTS_LOAD_FAILURE';
export const SKI_RENTAL_DISCOUNT_ADD = 'SKI_RENTAL_DISCOUNT_ADD';
export const SKI_RENTAL_DISCOUNT_CREATE_PENDING = 'SKI_RENTAL_DISCOUNT_CREATE_PENDING';
export const SKI_RENTAL_DISCOUNT_CREATE_SUCCESS = 'SKI_RENTAL_DISCOUNT_CREATE_SUCCESS';
export const SKI_RENTAL_DISCOUNT_CREATE_FAILURE = 'SKI_RENTAL_DISCOUNT_CREATE_FAILURE';
export const SKI_RENTAL_DISCOUNT_SAVE_PENDING = 'SKI_RENTAL_DISCOUNT_SAVE_PENDING';
export const SKI_RENTAL_DISCOUNT_SAVE_SUCCESS = 'SKI_RENTAL_DISCOUNT_SAVE_SUCCESS';
export const SKI_RENTAL_DISCOUNT_SAVE_FAILURE = 'SKI_RENTAL_DISCOUNT_SAVE_FAILURE';
export const SKI_RENTAL_DISCOUNT_REMOVE_PENDING = 'SKI_RENTAL_DISCOUNT_REMOVE_PENDING';
export const SKI_RENTAL_DISCOUNT_REMOVE_SUCCESS = 'SKI_RENTAL_DISCOUNT_REMOVE_SUCCESS';
export const SKI_RENTAL_DISCOUNT_REMOVE_FAILURE = 'SKI_RENTAL_DISCOUNT_REMOVE_FAILURE';

// Ski rental discount person category
export const SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_PENDING = 'SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_PENDING';
export const SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_SUCCESS = 'SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_SUCCESS';
export const SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_FAILURE = 'SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_FAILURE';
export const SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_PENDING = 'SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_PENDING';
export const SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_SUCCESS = 'SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_SUCCESS';
export const SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_FAILURE = 'SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_FAILURE';

// Ski rental season sales types
export const SKI_RENTAL_SALES_TYPES_LOAD_PENDING = 'SKI_RENTAL_SALES_TYPES_LOAD_PENDING';
export const SKI_RENTAL_SALES_TYPES_LOAD_SUCCESS = 'SKI_RENTAL_SALES_TYPES_LOAD_SUCCESS';
export const SKI_RENTAL_SALES_TYPES_LOAD_FAILURE = 'SKI_RENTAL_SALES_TYPES_LOAD_FAILURE';

// Ski rental packages
export const SKI_RENTAL_PACKAGES_LOAD_PENDING = 'SKI_RENTAL_PACKAGES_LOAD_PENDING';
export const SKI_RENTAL_PACKAGES_LOAD_SUCCESS = 'SKI_RENTAL_PACKAGES_LOAD_SUCCESS';
export const SKI_RENTAL_PACKAGES_LOAD_FAILURE = 'SKI_RENTAL_PACKAGES_LOAD_FAILURE';

// Ski rental levels
export const SKI_RENTAL_LEVELS_LOAD_PENDING = 'SKI_RENTAL_LEVELS_LOAD_PENDING';
export const SKI_RENTAL_LEVELS_LOAD_SUCCESS = 'SKI_RENTAL_LEVELS_LOAD_SUCCESS';
export const SKI_RENTAL_LEVELS_LOAD_FAILURE = 'SKI_RENTAL_LEVELS_LOAD_FAILURE';

// Ski rental ski types
export const SKI_RENTAL_SKI_TYPES_LOAD_PENDING = 'SKI_RENTAL_SKI_TYPES_LOAD_PENDING';
export const SKI_RENTAL_SKI_TYPES_LOAD_SUCCESS = 'SKI_RENTAL_SKI_TYPES_LOAD_SUCCESS';
export const SKI_RENTAL_SKI_TYPES_LOAD_FAILURE = 'SKI_RENTAL_SKI_TYPES_LOAD_FAILURE';

// Ski rental price combinations
export const SKI_RENTAL_PRICE_COMBINATIONS_LOAD_PENDING = 'SKI_RENTAL_PRICE_COMBINATIONS_LOAD_PENDING';
export const SKI_RENTAL_PRICE_COMBINATIONS_LOAD_SUCCESS = 'SKI_RENTAL_PRICE_COMBINATIONS_LOAD_SUCCESS';
export const SKI_RENTAL_PRICE_COMBINATIONS_LOAD_FAILURE = 'SKI_RENTAL_PRICE_COMBINATIONS_LOAD_FAILURE';
export const SKI_RENTAL_PRICE_COMBINATION_NUMBER_OF_DAYS_SET = 'SKI_RENTAL_PRICE_COMBINATION_NUMBER_OF_DAYS_SET';
export const SKI_RENTAL_PRICE_COMBINATION_PERSON_CATEGORY_SET = 'SKI_RENTAL_PRICE_COMBINATION_PERSON_CATEGORY_SET';
export const SKI_RENTAL_PRICE_COMBINATION_LEVEL_SET = 'SKI_RENTAL_PRICE_COMBINATION_LEVEL_SET';
export const SKI_RENTAL_PRICE_COMBINATION_PACKAGE_SET = 'SKI_RENTAL_PRICE_COMBINATION_PACKAGE_SET';
export const SKI_RENTAL_PRICE_COMBINATION_SKI_TYPE_SET = 'SKI_RENTAL_PRICE_COMBINATION_SKI_TYPE_SET';
export const SKI_RENTAL_PRICE_COMBINATION_CLEAR_FILTERS_SET = 'SKI_RENTAL_PRICE_COMBINATION_CLEAR_FILTERS_SET';
export const SKI_RENTAL_PRICE_COMBINATION_ONLY_SHOW_SAVED_PRICES_SET = 'SKI_RENTAL_PRICE_COMBINATION_ONLY_SHOW_SAVED_PRICES_SET';

// Ski rental prices
export const SKI_RENTAL_PRICE_SET = 'SKI_RENTAL_PRICE_SET';
export const SKI_RENTAL_PRICE_ADD = 'SKI_RENTAL_PRICE_ADD';
export const SKI_RENTAL_PRICES_LOAD_PENDING = 'SKI_RENTAL_PRICES_LOAD_PENDING';
export const SKI_RENTAL_PRICES_LOAD_SUCCESS = 'SKI_RENTAL_PRICES_LOAD_SUCCESS';
export const SKI_RENTAL_PRICES_LOAD_FAILURE = 'SKI_RENTAL_PRICES_LOAD_FAILURE';
export const SKI_RENTAL_PRICE_DAY_SET = 'SKI_RENTAL_PRICE_DAY_SET';
export const SKI_RENTAL_PRICE_CREATE_PENDING = 'SKI_RENTAL_PRICE_CREATE_PENDING';
export const SKI_RENTAL_PRICE_CREATE_SUCCESS = 'SKI_RENTAL_PRICE_CREATE_SUCCESS';
export const SKI_RENTAL_PRICE_CREATE_FAILURE = 'SKI_RENTAL_PRICE_CREATE_FAILURE';
export const SKI_RENTAL_PRICE_SAVE_PENDING = 'SKI_RENTAL_PRICE_SAVE_PENDING';
export const SKI_RENTAL_PRICE_SAVE_SUCCESS = 'SKI_RENTAL_PRICE_SAVE_SUCCESS';
export const SKI_RENTAL_PRICE_SAVE_FAILURE = 'SKI_RENTAL_PRICE_SAVE_FAILURE';
export const SKI_RENTAL_PRICE_REMOVE_PENDING = 'SKI_RENTAL_PRICE_REMOVE_PENDING';
export const SKI_RENTAL_PRICE_REMOVE_SUCCESS = 'SKI_RENTAL_PRICE_REMOVE_SUCCESS';
export const SKI_RENTAL_PRICE_REMOVE_FAILURE = 'SKI_RENTAL_PRICE_REMOVE_FAILURE';

// Ski rental areas
export const SKI_RENTAL_AREAS_LOAD_PENDING = 'SKI_RENTAL_AREAS_LOAD_PENDING';
export const SKI_RENTAL_AREAS_LOAD_SUCCESS = 'SKI_RENTAL_AREAS_LOAD_SUCCESS';
export const SKI_RENTAL_AREAS_LOAD_FAILURE = 'SKI_RENTAL_AREAS_LOAD_FAILURE';
export const SKI_RENTAL_AREAS_SAVE_PENDING = 'SKI_RENTAL_AREAS_SAVE_PENDING';
export const SKI_RENTAL_AREAS_SAVE_SUCCESS = 'SKI_RENTAL_AREAS_SAVE_SUCCESS';
export const SKI_RENTAL_AREAS_SAVE_FAILURE = 'SKI_RENTAL_AREAS_SAVE_FAILURE';
export const SKI_RENTAL_AREAS_DELETE_PENDING = 'SKI_RENTAL_AREAS_DELETE_PENDING';
export const SKI_RENTAL_AREAS_DELETE_SUCCESS = 'SKI_RENTAL_AREAS_DELETE_SUCCESS';
export const SKI_RENTAL_AREAS_DELETE_FAILURE = 'SKI_RENTAL_AREAS_DELETE_FAILURE';

export const SKI_RENTAL_SEASON_PICK_UP_PLACES_PENDING= 'SKI_RENTAL_SEASON_PICK_UP_PLACES_PENDING';
export const SKI_RENTAL_SEASON_PICK_UP_PLACES_SUCCESS = 'SKI_RENTAL_SEASON_PICK_UP_PLACES_SUCCESS';
export const SKI_RENTAL_SEASON_PICK_UP_PLACES_FAILURE = 'SKI_RENTAL_SEASON_PICK_UP_PLACES_FAILURE';

/*
  -----------------

  Non dynamic transportation

  -----------------
 */

// Suppliers
export const NON_DYNAMIC_TRANSPORT_SUPPLIERS_PENDING = 'NON_DYNAMIC_TRANSPORT_SUPPLIERS_PENDING';
export const NON_DYNAMIC_TRANSPORT_SUPPLIERS_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SUPPLIERS_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SUPPLIERS_FAILURE = 'NON_DYNAMIC_TRANSPORT_SUPPLIERS_FAILURE';

// Transits
export const NON_DYNAMIC_TRANSPORT_TRANSITS_PENDING = 'NON_DYNAMIC_TRANSPORT_TRANSITS_PENDING';
export const NON_DYNAMIC_TRANSPORT_TRANSITS_SUCCESS = 'NON_DYNAMIC_TRANSPORT_TRANSITS_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_TRANSITS_FAILURE = 'NON_DYNAMIC_TRANSPORT_TRANSITS_FAILURE';

// Carriers
export const NON_DYNAMIC_TRANSPORT_CARRIERS_PENDING = 'NON_DYNAMIC_TRANSPORT_CARRIERS_PENDING';
export const NON_DYNAMIC_TRANSPORT_CARRIERS_SUCCESS = 'NON_DYNAMIC_TRANSPORT_CARRIERS_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_CARRIERS_FAILURE = 'NON_DYNAMIC_TRANSPORT_CARRIERS_FAILURE';
export const NON_DYNAMIC_TRANSPORT_CARRIERS_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_CARRIERS_NO_CONTENT';

// Load transportation
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_PENDING = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_PENDING';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_SUCCESS = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_FAILURE = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_FAILURE';

// Save transportation
export const NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_PENDING = 'NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_PENDING';
export const NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_FAILURE = 'NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_FAILURE';

// Save sibling transportation
export const NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_PENDING = 'NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_PENDING';
export const NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_FAILURE = 'NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_FAILURE';

// Upload contracts
export const NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_PENDING = 'NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_PENDING';
export const NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_SUCCESS = 'NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_FAILURE = 'NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_FAILURE';

// Seating section types
export const NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_PENDING = 'NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_PENDING';
export const NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_FAILURE = 'NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_FAILURE';
export const NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_NO_CONTENT';

// Consumable types
export const NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_PENDING = 'NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_PENDING';
export const NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_SUCCESS = 'NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_FAILURE = 'NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_FAILURE';
export const NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_NO_CONTENT';

// Upgrade types
export const NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_PENDING = 'NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_PENDING';
export const NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_SUCCESS = 'NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_FAILURE = 'NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_FAILURE';
export const NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_NO_CONTENT';

// Sync transportation trip seatings
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_PENDING = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_PENDING';
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_FAILURE = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_FAILURE';

// Sync transportation trip consumables
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_PENDING = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_PENDING';
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_FAILURE = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_FAILURE';

// Sync transportation trip upgrades
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_PENDING = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_PENDING';
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_FAILURE = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_FAILURE';

// Get transportation trip seatings
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_PENDING = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_PENDING';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_SUCCESS = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_FAILURE = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_FAILURE';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_NO_CONTENT';

// Get transportation trip consumables
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_PENDING = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_PENDING';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_SUCCESS = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_FAILURE = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_FAILURE';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_NO_CONTENT';

// Get transportation trip upgrades
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_PENDING = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_PENDING';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_SUCCESS = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_FAILURE = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_FAILURE';
export const NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_NO_CONTENT';

// Get luggage types
export const NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_PENDING = 'NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_PENDING';
export const NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_SUCCESS = 'NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_FAILURE = 'NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_FAILURE';
export const NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_NO_CONTENT';

// Sync transportation luggage
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_PENDING = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_PENDING';
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_FAILURE = 'NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_FAILURE';

// Get transportation luggage
export const NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_PENDING = 'NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_PENDING';
export const NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_SUCCESS = 'NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_FAILURE = 'NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_FAILURE';
export const NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_NO_CONTENT';

// Get transportation contracts
export const NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_PENDING = 'NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_PENDING';
export const NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_SUCCESS = 'NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_FAILURE = 'NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_FAILURE';
export const NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_NO_CONTENT';

// Search transports
export const NON_DYNAMIC_TRANSPORT_SEARCH_PENDING = 'NON_DYNAMIC_TRANSPORT_SEARCH_PENDING';
export const NON_DYNAMIC_TRANSPORT_SEARCH_SUCCESS = 'NON_DYNAMIC_TRANSPORT_SEARCH_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_SEARCH_FAILURE = 'NON_DYNAMIC_TRANSPORT_SEARCH_FAILURE';
export const NON_DYNAMIC_TRANSPORT_SEARCH_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_SEARCH_NO_CONTENT';

// Get transports
export const NON_DYNAMIC_TRANSPORT_GET_LIST_PENDING = 'NON_DYNAMIC_TRANSPORT_GET_LIST_PENDING';
export const NON_DYNAMIC_TRANSPORT_GET_LIST_SUCCESS = 'NON_DYNAMIC_TRANSPORT_GET_LIST_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_GET_LIST_FAILURE = 'NON_DYNAMIC_TRANSPORT_GET_LIST_FAILURE';

// Search transports price setting
export const NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_PENDING = 'NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_PENDING';
export const NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_SUCCESS = 'NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_SUCCESS';
export const NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_FAILURE = 'NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_FAILURE';
export const NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_NO_CONTENT = 'NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_NO_CONTENT';

/*
  -----------------

  Transportation (Ferry & Train)

  -----------------
 */
export const TRANSPORTATION_CLEAR_STATE = 'TRANSPORTATION_CLEAR_STATE';
export const TRANSPORTATION_ACTIVE_TAB_SET = 'TRANSPORTATION_ACTIVE_TAB_SET';

// Cabins
export const TRANSPORTATION_CABINS_SEARCH = 'TRANSPORTATION_CABINS_SEARCH';
export const TRANSPORTATION_CABINS_ITEMS_CLEAR = 'TRANSPORTATION_CABINS_ITEMS_CLEAR';
export const TRANSPORTATION_CABINS_LOAD_PENDING = 'TRANSPORTATION_CABINS_LOAD_PENDING';
export const TRANSPORTATION_CABINS_LOAD_SUCCESS = 'TRANSPORTATION_CABINS_LOAD_SUCCESS';
export const TRANSPORTATION_CABINS_LOAD_FAILURE = 'TRANSPORTATION_CABINS_LOAD_FAILURE';
export const TRANSPORTATION_CABINS_LOAD_NO_CONTENT = 'TRANSPORTATION_CABINS_LOAD_NO_CONTENT';
export const TRANSPORTATION_CABINS_LOAD_PRICES_PENDING = 'TRANSPORTATION_CABINS_LOAD_PRICES_PENDING';
export const TRANSPORTATION_CABINS_LOAD_PRICES_SUCCESS = 'TRANSPORTATION_CABINS_LOAD_PRICES_SUCCESS';
export const TRANSPORTATION_CABINS_LOAD_PRICES_FAILURE = 'TRANSPORTATION_CABINS_LOAD_PRICES_FAILURE';
export const TRANSPORTATION_CABINS_ADD_PENDING = 'TRANSPORTATION_CABINS_ADD_PENDING';
export const TRANSPORTATION_CABINS_ADD_SUCCESS = 'TRANSPORTATION_CABINS_ADD_SUCCESS';
export const TRANSPORTATION_CABINS_ADD_FAILURE = 'TRANSPORTATION_CABINS_ADD_FAILURE';
export const TRANSPORTATION_CABINS_SAVE_PENDING = 'TRANSPORTATION_CABINS_SAVE_PENDING';
export const TRANSPORTATION_CABINS_SAVE_SUCCESS = 'TRANSPORTATION_CABINS_SAVE_SUCCESS';
export const TRANSPORTATION_CABINS_SAVE_FAILURE = 'TRANSPORTATION_CABINS_SAVE_FAILURE';
export const TRANSPORTATION_CABINS_SET_ACTIVE = 'TRANSPORTATION_CABINS_SET_ACTIVE';
export const TRANSPORTATION_CABINS_SET_ROUTE = 'TRANSPORTATION_CABINS_SET_ROUTE';

// Extras
export const TRANSPORTATION_EXTRAS_SEARCH = 'TRANSPORTATION_EXTRAS_SEARCH';
export const TRANSPORTATION_EXTRAS_ITEMS_CLEAR = 'TRANSPORTATION_EXTRAS_ITEMS_CLEAR';
export const TRANSPORTATION_EXTRAS_LOAD_PENDING = 'TRANSPORTATION_EXTRAS_LOAD_PENDING';
export const TRANSPORTATION_EXTRAS_LOAD_SUCCESS = 'TRANSPORTATION_EXTRAS_LOAD_SUCCESS';
export const TRANSPORTATION_EXTRAS_LOAD_FAILURE = 'TRANSPORTATION_EXTRAS_LOAD_FAILURE';
export const TRANSPORTATION_EXTRAS_LOAD_NO_CONTENT = 'TRANSPORTATION_EXTRAS_LOAD_NO_CONTENT';
export const TRANSPORTATION_EXTRAS_ADD_PENDING = 'TRANSPORTATION_EXTRAS_ADD_PENDING';
export const TRANSPORTATION_EXTRAS_ADD_SUCCESS = 'TRANSPORTATION_EXTRAS_ADD_SUCCESS';
export const TRANSPORTATION_EXTRAS_ADD_FAILURE = 'TRANSPORTATION_EXTRAS_ADD_FAILURE';
export const TRANSPORTATION_EXTRAS_SAVE_PENDING = 'TRANSPORTATION_EXTRAS_SAVE_PENDING';
export const TRANSPORTATION_EXTRAS_SAVE_SUCCESS = 'TRANSPORTATION_EXTRAS_SAVE_SUCCESS';
export const TRANSPORTATION_EXTRAS_SAVE_FAILURE = 'TRANSPORTATION_EXTRAS_SAVE_FAILURE';
export const TRANSPORTATION_EXTRAS_SET_ACTIVE = 'TRANSPORTATION_EXTRAS_SET_ACTIVE';
export const TRANSPORTATION_EXTRAS_SET_ROUTE = 'TRANSPORTATION_EXTRAS_SET_ROUTE';

// Prices season
export const TRANSPORTATION_PRICES_SET_ROUTE = 'TRANSPORTATION_PRICES_SET_ROUTE';
export const TRANSPORTATION_PRICES_CLEAR = 'TRANSPORTATION_PRICES_CLEAR';
export const TRANSPORTATION_PRICES_SET_SEASON = 'TRANSPORTATION_PRICES_SET_SEASON';
export const TRANSPORTATION_PRICES_UNSET_SEASON = 'TRANSPORTATION_PRICES_UNSET_SEASON';
export const TRANSPORTATION_PRICES_SEASONS_LIST_UPDATE = 'TRANSPORTATION_PRICES_SEASONS_LIST_UPDATE';
export const TRANSPORTATION_PRICES_SEASONS_LOAD_PENDING = 'TRANSPORTATION_PRICES_SEASONS_LOAD_PENDING';
export const TRANSPORTATION_PRICES_SEASONS_LOAD_SUCCESS = 'TRANSPORTATION_PRICES_SEASONS_LOAD_SUCCESS';
export const TRANSPORTATION_PRICES_SEASONS_LOAD_NO_CONTENT = 'TRANSPORTATION_PRICES_SEASONS_LOAD_NO_CONTENT';
export const TRANSPORTATION_PRICES_SEASONS_LOAD_FAILURE = 'TRANSPORTATION_PRICES_SEASONS_LOAD_FAILURE';
export const TRANSPORTATION_PRICES_SEASON_ADD_PENDING = 'TRANSPORTATION_PRICES_SEASON_ADD_PENDING';
export const TRANSPORTATION_PRICES_SEASON_ADD_SUCCESS = 'TRANSPORTATION_PRICES_SEASON_ADD_SUCCESS';
export const TRANSPORTATION_PRICES_SEASON_ADD_FAILURE = 'TRANSPORTATION_PRICES_SEASON_ADD_FAILURE';
export const TRANSPORTATION_PRICES_SEASON_UPDATE_PENDING = 'TRANSPORTATION_PRICES_SEASON_UPDATE_PENDING';
export const TRANSPORTATION_PRICES_SEASON_UPDATE_SUCCESS = 'TRANSPORTATION_PRICES_SEASON_UPDATE_SUCCESS';
export const TRANSPORTATION_PRICES_SEASON_UPDATE_FAILURE = 'TRANSPORTATION_PRICES_SEASON_UPDATE_FAILURE';

// Prices season transportation
export const TRANSPORTATION_PRICES_SET_FERRY_SEASON = 'TRANSPORTATION_PRICES_SET_FERRY_SEASON';
export const TRANSPORTATION_PRICES_UNSET_FERRY_SEASON = 'TRANSPORTATION_PRICES_UNSET_FERRY_SEASON';
export const TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_PENDING = 'TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_PENDING';
export const TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_SUCCESS = 'TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_SUCCESS';
export const TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_NO_CONTENT = 'TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_NO_CONTENT';
export const TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_FAILURE = 'TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_FAILURE';

export const TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_PENDING = 'TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_PENDING';
export const TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_SUCCESS = 'TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_SUCCESS';
export const TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_NO_CONTENT = 'TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_NO_CONTENT';
export const TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_FAILURE = 'TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_FAILURE';
export const TRANSPORTATION_PRICES_SEASON_FERRY_ADD_PENDING = 'TRANSPORTATION_PRICES_SEASON_FERRY_ADD_PENDING';

export const TRANSPORTATION_PRICES_SEASON_FERRY_ADD_SUCCESS = 'TRANSPORTATION_PRICES_SEASON_FERRY_ADD_SUCCESS';
export const TRANSPORTATION_PRICES_SEASON_FERRY_ADD_FAILURE = 'TRANSPORTATION_PRICES_SEASON_FERRY_ADD_FAILURE';
export const TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_PENDING = 'TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_PENDING';
export const TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_SUCCESS = 'TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_SUCCESS';
export const TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_FAILURE = 'TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_FAILURE';
export const TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_PENDING = 'TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_PENDING';
export const TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_SUCCESS = 'TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_SUCCESS';
export const TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_FAILURE = 'TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_FAILURE';

// Prices departure
export const TRANSPORTATION_PRICES_DEPARTURE_SET = 'TRANSPORTATION_PRICES_DEPARTURE_SET';
export const TRANSPORTATION_PRICES_DEPARTURE_SET_DIRECTION = 'TRANSPORTATION_PRICES_DEPARTURE_SET_DIRECTION';
export const TRANSPORTATION_PRICES_DEPARTURES_PENDING = 'TRANSPORTATION_PRICES_DEPARTURES_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURES_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURES_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURES_NO_CONTENT = 'TRANSPORTATION_PRICES_DEPARTURES_NO_CONTENT';
export const TRANSPORTATION_PRICES_DEPARTURES_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURES_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_SAVE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_SAVE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_SAVE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_SAVE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_SAVE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_SAVE_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_DELETE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_DELETE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_DELETE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_DELETE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_DELETE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_DELETE_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_ADD_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_ADD_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_ADD_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_ADD_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_ADD_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_ADD_FAILURE';

// Prices departure days
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_FAILURE';

// Price departure cabins
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_NO_CONTENT = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_NO_CONTENT';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_FAILURE';

//Price departure extras
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_FAILURE';

// Price departure block days
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_FAILURE';
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_DELETE_PENDING = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_DELETE_PENDING';
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_DELETE_SUCCESS = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_DELETE_SUCCESS';
export const TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_DELETE_FAILURE = 'TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_DELETE_FAILURE';

// Car Types
export const TRANSPORTATION_CAR_TYPES_SEARCH = 'TRANSPORTATION_CAR_TYPES_SEARCH';
export const TRANSPORTATION_CAR_TYPES_PAGINATION_CHANGED = 'TRANSPORTATION_CAR_TYPES_PAGINATION_CHANGED';
export const TRANSPORTATION_CAR_TYPES_LOAD_PENDING = 'TRANSPORTATION_CAR_TYPES_LOAD_PENDING';
export const TRANSPORTATION_CAR_TYPES_LOAD_SUCCESS = 'TRANSPORTATION_CAR_TYPES_LOAD_SUCCESS';
export const TRANSPORTATION_CAR_TYPES_LOAD_NO_CONTENT = 'TRANSPORTATION_CAR_TYPES_LOAD_NO_CONTENT';
export const TRANSPORTATION_CAR_TYPES_LOAD_FAILURE = 'TRANSPORTATION_CAR_TYPES_LOAD_FAILURE';
export const TRANSPORTATION_CAR_TYPES_SAVE_PENDING = 'TRANSPORTATION_CAR_TYPES_SAVE_PENDING';
export const TRANSPORTATION_CAR_TYPES_SAVE_SUCCESS = 'TRANSPORTATION_CAR_TYPES_SAVE_SUCCESS';
export const TRANSPORTATION_CAR_TYPES_SAVE_FAILURE = 'TRANSPORTATION_CAR_TYPES_SAVE_FAILURE';
export const TRANSPORTATION_CAR_TYPES_SET_ACTIVE = 'TRANSPORTATION_CAR_TYPES_SET_ACTIVE';
export const TRANSPORTATION_CAR_TYPES_ADD_PENDING = 'TRANSPORTATION_CAR_TYPES_ADD_PENDING';
export const TRANSPORTATION_CAR_TYPES_ADD_SUCCESS = 'TRANSPORTATION_CAR_TYPES_ADD_SUCCESS';
export const TRANSPORTATION_CAR_TYPES_ADD_FAILURE = 'TRANSPORTATION_CAR_TYPES_ADD_FAILURE';

// Person Categories
export const TRANSPORTATION_PERSON_CATEGORIES_LOAD_PENDING = 'TRANSPORTATION_PERSON_CATEGORIES_LOAD_PENDING';
export const TRANSPORTATION_PERSON_CATEGORIES_LOAD_SUCCESS = 'TRANSPORTATION_PERSON_CATEGORIES_LOAD_SUCCESS';
export const TRANSPORTATION_PERSON_CATEGORIES_LOAD_NO_CONTENT = 'TRANSPORTATION_PERSON_CATEGORIES_LOAD_NO_CONTENT';
export const TRANSPORTATION_PERSON_CATEGORIES_LOAD_FAILURE = 'TRANSPORTATION_PERSON_CATEGORIES_LOAD_FAILURE';
export const TRANSPORTATION_PERSON_CATEGORIES_SEARCH = 'TRANSPORTATION_PERSON_CATEGORIES_SEARCH';
export const TRANSPORTATION_PERSON_CATEGORIES_SET_ACTIVE = 'TRANSPORTATION_PERSON_CATEGORIES_SET_ACTIVE';
export const TRANSPORTATION_PERSON_CATEGORIES_SAVE_PENDING = 'TRANSPORTATION_PERSON_CATEGORIES_SAVE_PENDING';
export const TRANSPORTATION_PERSON_CATEGORIES_SAVE_SUCCESS = 'TRANSPORTATION_PERSON_CATEGORIES_SAVE_SUCCESS';
export const TRANSPORTATION_PERSON_CATEGORIES_SAVE_FAILURE = 'TRANSPORTATION_PERSON_CATEGORIES_SAVE_FAILURE';
export const TRANSPORTATION_PERSON_CATEGORIES_ADD_PENDING = 'TRANSPORTATION_PERSON_CATEGORIES_ADD_PENDING';
export const TRANSPORTATION_PERSON_CATEGORIES_ADD_SUCCESS = 'TRANSPORTATION_PERSON_CATEGORIES_ADD_SUCCESS';
export const TRANSPORTATION_PERSON_CATEGORIES_ADD_FAILURE = 'TRANSPORTATION_PERSON_CATEGORIES_ADD_FAILURE';
export const TRANSPORTATION_PERSON_CATEGORIES_PAGINATION_CHANGED = 'TRANSPORTATION_PERSON_CATEGORIES_PAGINATION_CHANGED';

// Routes
export const TRANSPORTATION_ROUTES_SEARCH = 'TRANSPORTATION_ROUTES_SEARCH';
export const TRANSPORTATION_ROUTES_PAGINATION_CHANGED = 'TRANSPORTATION_ROUTES_PAGINATION_CHANGED';
export const TRANSPORTATION_ROUTES_LOAD_PENDING = 'TRANSPORTATION_ROUTES_LOAD_PENDING';
export const TRANSPORTATION_ROUTES_LOAD_SUCCESS = 'TRANSPORTATION_ROUTES_LOAD_SUCCESS';
export const TRANSPORTATION_ROUTES_LOAD_NO_CONTENT = 'TRANSPORTATION_ROUTES_LOAD_NO_CONTENT';
export const TRANSPORTATION_ROUTES_LOAD_FAILURE = 'TRANSPORTATION_ROUTES_LOAD_FAILURE';
export const TRANSPORTATION_ROUTES_SAVE_PENDING = 'TRANSPORTATION_ROUTES_SAVE_PENDING';
export const TRANSPORTATION_ROUTES_SAVE_SUCCESS = 'TRANSPORTATION_ROUTES_SAVE_SUCCESS';
export const TRANSPORTATION_ROUTES_SAVE_FAILURE = 'TRANSPORTATION_ROUTES_SAVE_FAILURE';
export const TRANSPORTATION_ROUTES_AREAS_LOAD_PENDING = 'TRANSPORTATION_ROUTES_AREAS_LOAD_PENDING';
export const TRANSPORTATION_ROUTES_AREAS_LOAD_SUCCESS = 'TRANSPORTATION_ROUTES_AREAS_LOAD_SUCCESS';
export const TRANSPORTATION_ROUTES_AREAS_LOAD_FAILURE = 'TRANSPORTATION_ROUTES_AREAS_LOAD_FAILURE';
export const TRANSPORTATION_ROUTES_SET_ACTIVE = 'TRANSPORTATION_ROUTES_SET_ACTIVE';
export const TRANSPORTATION_ROUTES_AREAS_ADD = 'TRANSPORTATION_ROUTES_AREAS_ADD';
export const TRANSPORTATION_ROUTES_AREAS_TOGGLE = 'TRANSPORTATION_ROUTES_AREAS_TOGGLE';
export const TRANSPORTATION_ROUTES_AREAS_DELETE = 'TRANSPORTATION_ROUTES_AREAS_DELETE';
export const TRANSPORTATION_ROUTES_AREAS_REPLACE_ALL = 'TRANSPORTATION_ROUTES_AREAS_REPLACE_ALL';
export const TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_PENDING = 'TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_PENDING';
export const TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_SUCCESS = 'TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_SUCCESS';
export const TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_NO_CONTENT = 'TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_NO_CONTENT';
export const TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_FAILURE = 'TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_FAILURE';
export const TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_PENDING = 'TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_PENDING';
export const TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_SUCCESS = 'TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_SUCCESS';
export const TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_FAILURE = 'TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_FAILURE';
export const TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_PENDING = 'TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_PENDING';
export const TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_SUCCESS = 'TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_SUCCESS';
export const TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_FAILURE = 'TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_FAILURE';
export const TRANSPORTATION_ROUTES_TEXTS_LOAD_PENDING = 'TRANSPORTATION_ROUTES_TEXTS_LOAD_PENDING';
export const TRANSPORTATION_ROUTES_TEXTS_LOAD_SUCCESS = 'TRANSPORTATION_ROUTES_TEXTS_LOAD_SUCCESS';
export const TRANSPORTATION_ROUTES_TEXTS_LOAD_FAILURE = 'TRANSPORTATION_ROUTES_TEXTS_LOAD_FAILURE';
export const TRANSPORTATION_ROUTES_TEXTS_CLEAR_LIST = 'TRANSPORTATION_ROUTES_TEXTS_CLEAR_LIST';
export const TRANSPORTATION_ROUTES_CREATE_TEXT_PENDING = 'TRANSPORTATION_ROUTES_CREATE_TEXT_PENDING';
export const TRANSPORTATION_ROUTES_CREATE_TEXT_SUCCESS = 'TRANSPORTATION_ROUTES_CREATE_TEXT_SUCCESS';
export const TRANSPORTATION_ROUTES_CREATE_TEXT_FAILURE = 'TRANSPORTATION_ROUTES_CREATE_TEXT_FAILURE';
export const TRANSPORTATION_ROUTES_UPDATE_TEXT_PENDING = 'TRANSPORTATION_ROUTES_UPDATE_TEXT_PENDING';
export const TRANSPORTATION_ROUTES_UPDATE_TEXT_SUCCESS = 'TRANSPORTATION_ROUTES_UPDATE_TEXT_SUCCESS';
export const TRANSPORTATION_ROUTES_UPDATE_TEXT_FAILURE = 'TRANSPORTATION_ROUTES_UPDATE_TEXT_FAILURE';
export const TRANSPORTATION_ROUTES_DELETE_TEXT_PENDING = 'TRANSPORTATION_ROUTES_DELETE_TEXT_PENDING';
export const TRANSPORTATION_ROUTES_DELETE_TEXT_SUCCESS = 'TRANSPORTATION_ROUTES_DELETE_TEXT_SUCCESS';
export const TRANSPORTATION_ROUTES_DELETE_TEXT_FAILURE = 'TRANSPORTATION_ROUTES_DELETE_TEXT_FAILURE';
export const TRANSPORTATION_ROUTES_CHANGE_TEXT = 'TRANSPORTATION_ROUTES_CHANGE_TEXT';

// Suppliers
export const TRANSPORTATION_SUPPLIERS_LOAD_PENDING = 'TRANSPORTATION_SUPPLIERS_LOAD_PENDING';
export const TRANSPORTATION_SUPPLIERS_LOAD_SUCCESS = 'TRANSPORTATION_SUPPLIERS_LOAD_SUCCESS';
export const TRANSPORTATION_SUPPLIERS_LOAD_FAILURE = 'TRANSPORTATION_SUPPLIERS_LOAD_FAILURE';
export const TRANSPORTATION_SUPPLIERS_CHANGE = 'TRANSPORTATION_SUPPLIERS_CHANGE';

// Ski areas
export const SKI_STATE_RESET = 'SKI_STATE_RESET';
export const SKI_AREAS_LIST_PENDING = 'SKI_AREAS_LIST_PENDING';
export const SKI_AREAS_LIST_SUCCESS = 'SKI_AREAS_LIST_SUCCESS';
export const SKI_AREAS_LIST_FAILURE = 'SKI_AREAS_LIST_FAILURE';
export const SKI_FACTS_GET_PENDING = 'SKI_FACTS_GET_PENDING';
export const SKI_FACTS_GET_SUCCESS = 'SKI_FACTS_GET_SUCCESS';
export const SKI_FACTS_GET_FAILURE = 'SKI_FACTS_GET_FAILURE';
export const SKI_SNOW_GUARANTEE_GET_PENDING = 'SKI_SNOW_GUARANTEE_GET_PENDING';
export const SKI_SNOW_GUARANTEE_GET_SUCCESS = 'SKI_SNOW_GUARANTEE_GET_SUCCESS';
export const SKI_SNOW_GUARANTEE_GET_FAILURE = 'SKI_SNOW_GUARANTEE_GET_FAILURE';
export const SKI_FACTS_UPDATE_PENDING = 'SKI_FACTS_UPDATE_PENDING';
export const SKI_FACTS_UPDATE_SUCCESS = 'SKI_FACTS_UPDATE_SUCCESS';
export const SKI_FACTS_UPDATE_FAILURE = 'SKI_FACTS_UPDATE_FAILURE';
export const SKI_FACT_SET = 'SKI_FACT_SET';
export const SKI_FACT_CHECK_VALUED = 'SKI_FACT_CHECK_VALUED';
export const SKI_FACT_CHECK_ALL = 'SKI_FACT_CHECK_ALL';
export const SKI_SNOW_GUARANTEE_SET = 'SKI_SNOW_GUARANTEE_SET';
export const SKI_SNOW_GUARANTEE_UPDATE_PENDING = 'SKI_SNOW_GUARANTEE_UPDATE_PENDING';
export const SKI_SNOW_GUARANTEE_UPDATE_SUCCESS = 'SKI_SNOW_GUARANTEE_UPDATE_SUCCESS';
export const SKI_SNOW_GUARANTEE_UPDATE_FAILURE = 'SKI_SNOW_GUARANTEE_UPDATE_FAILURE';
export const SKI_SLOPE_MAPS_PENDING = 'SKI_SLOPE_MAPS_PENDING';
export const SKI_SLOPE_MAPS_SUCCESS = 'SKI_SLOPE_MAPS_SUCCESS';
export const SKI_SLOPE_MAPS_FAILURE = 'SKI_SLOPE_MAPS_FAILURE';
export const SKI_AREA_SET = 'SKI_AREA_SET';
export const SKI_AREA_PENDING = 'SKI_AREA_PENDING';
export const SKI_AREA_SUCCESS = 'SKI_AREA_SUCCESS';
export const SKI_AREA_FAILURE = 'SKI_AREA_FAILURE';
export const SKI_SLOPE_MAP_ADD_PENDING = 'SKI_SLOPE_MAP_ADD_PENDING';
export const SKI_SLOPE_MAP_ADD_SUCCESS = 'SKI_SLOPE_MAP_ADD_SUCCESS';
export const SKI_SLOPE_MAP_ADD_FAILURE = 'SKI_SLOPE_MAP_ADD_FAILURE';
export const SKI_SLOPE_MAP_REMOVE_PENDING = 'SKI_SLOPE_MAP_REMOVE_PENDING';
export const SKI_SLOPE_MAP_REMOVE_SUCCESS = 'SKI_SLOPE_MAP_REMOVE_SUCCESS';
export const SKI_SLOPE_MAP_REMOVE_FAILURE = 'SKI_SLOPE_MAP_REMOVE_FAILURE';
export const SKI_SLOPE_MAP_UPDATE_PENDING = 'SKI_SLOPE_MAP_UPDATE_PENDING';
export const SKI_SLOPE_MAP_UPDATE_SUCCESS = 'SKI_SLOPE_MAP_UPDATE_SUCCESS';
export const SKI_SLOPE_MAP_UPDATE_FAILURE = 'SKI_SLOPE_MAP_UPDATE_FAILURE';

// Skistar
export const SKI_SKISTAR_CLEAR_STATE = 'SKI_SKISTAR_CLEAR_STATE';
export const SKI_SKISTAR_RESORT_LOAD_PENDING = 'SKI_SKISTAR_RESORT_LOAD_PENDING';
export const SKI_SKISTAR_RESORT_LOAD_SUCCESS = 'SKI_SKISTAR_RESORT_LOAD_SUCCESS';
export const SKI_SKISTAR_RESORT_LOAD_FAILURE = 'SKI_SKISTAR_RESORT_LOAD_FAILURE';
export const SKI_SKISTAR_RESORT_CHANGE = 'SKI_SKISTAR_RESORT_CHANGE';
export const SKI_SKISTAR_RESORT_WEBSERVICE_CHANGE = 'SKI_SKISTAR_RESORT_WEBSERVICE_CHANGE';
export const SKI_SKISTAR_ACCOMMODATIONS_LOAD_PENDING = 'SKI_SKISTAR_ACCOMMODATIONS_LOAD_PENDING';
export const SKI_SKISTAR_ACCOMMODATIONS_LOAD_SUCCESS = 'SKI_SKISTAR_ACCOMMODATIONS_LOAD_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATIONS_LOAD_FAILURE = 'SKI_SKISTAR_ACCOMMODATIONS_LOAD_FAILURE';
export const SKI_SKISTAR_AREAS_SEARCH = 'SKI_SKISTAR_AREAS_SEARCH';
export const SKI_SKISTAR_SUBAREAS_SET = 'SKI_SKISTAR_SUBAREAS_SET';
export const SKI_SKISTAR_SUBAREA_CHANGE = 'SKI_SKISTAR_SUBAREAS_CHANGE';
export const SKI_SKISTAR_SUPPLIER_LOAD_PENDING = 'SKI_SKISTAR_SUPPLIER_LOAD_PENDING';
export const SKI_SKISTAR_SUPPLIER_LOAD_SUCCESS = 'SKI_SKISTAR_SUPPLIER_LOAD_SUCCESS';
export const SKI_SKISTAR_SUPPLIER_LOAD_FAILURE = 'SKI_SKISTAR_SUPPLIER_LOAD_FAILURE';
export const SKI_SKISTAR_SITES_LOAD_PENDING = 'SKI_SKISTAR_SITES_LOAD_PENDING';
export const SKI_SKISTAR_SITES_LOAD_SUCCESS = 'SKI_SKISTAR_SITES_LOAD_SUCCESS';
export const SKI_SKISTAR_SITES_LOAD_FAILURE = 'SKI_SKISTAR_SITES_LOAD_FAILURE';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_SITE_CHANGE = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_SITE_CHANGE';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_SUPPLIER_CHANGE = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_SUPPLIER_CHANGE';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_CATEGORY_CHANGE = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_CATEGORY_CHANGE';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_PENDING = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_FAILURE';
export const SKI_SKISTAR_ACCOMMODATION_TEXTS_PENDING = 'SKI_SKISTAR_ACCOMMODATION_TEXTS_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_TEXTS_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_TEXTS_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_TEXTS_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_TEXTS_FAILURE';
export const SKI_SKISTAR_ACCOMMODATION_TEXTS_NOCONTENT = 'SKI_SKISTAR_ACCOMMODATION_TEXTS_NOCONTENT';
export const SKI_SKISTAR_ACCOMMODATION_TEXTS_CLOSE = 'SKI_SKISTAR_ACCOMMODATION_TEXTS_CLOSE';
export const SKI_SKISTAR_ACCOMMODATION_IMAGES_PENDING = 'SKI_SKISTAR_ACCOMMODATION_IMAGES_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_IMAGES_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_IMAGES_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_IMAGES_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_IMAGES_FAILURE';
export const SKI_SKISTAR_ACCOMMODATION_IMAGES_NOCONTENT = 'SKI_SKISTAR_ACCOMMODATION_IMAGES_NOCONTENT';
export const SKI_SKISTAR_ACCOMMODATION_IMAGES_CLOSE = 'SKI_SKISTAR_ACCOMMODATION_IMAGES_CLOSE';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_PENDING = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_FAILURE';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_PENDING = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_FAILURE';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_PENDING = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_FAILURE';
export const SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_PENDING = 'SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_PENDING';
export const SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_SUCCESS = 'SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_SUCCESS';
export const SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_FAILURE = 'SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_FAILURE';
export const SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_NO_CONTENT = 'SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_NO_CONTENT';
export const SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_PENDING = 'SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_FAILURE';
export const SKI_SKISTAR_ACCOMMODATION_SELECTION_REMOVE = 'SKI_SKISTAR_ACCOMMODATION_SELECTION_REMOVE';
export const SKI_SKISTAR_ACCOMMODATION_SELECTION_ADD = 'SKI_SKISTAR_ACCOMMODATION_SELECTION_ADD';
export const SKI_SKISTAR_ACCOMMODATION_SELECTION_TOGGLE_ALL = 'SKI_SKISTAR_ACCOMMODATION_SELECTION_TOGGLE_ALL';
export const SKI_SKISTAR_ACCOMMODATION_SELECTION_REMOVE_IMPORTED = 'SKI_SKISTAR_ACCOMMODATION_SELECTION_REMOVE_IMPORTED';
export const SKI_SKISTAR_ACCOMMODATION_UNMAP_DIALOG = 'SKI_SKISTAR_ACCOMMODATION_UNMAP_DIALOG';
export const SKI_SKISTAR_ACCOMMODATION_UNMAP_RESET = 'SKI_SKISTAR_ACCOMMODATION_UNMAP_RESET';
export const SKI_SKISTAR_ACCOMMODATION_UNMAP_PENDING = 'SKI_SKISTAR_ACCOMMODATION_UNMAP_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_UNMAP_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_UNMAP_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_UNMAP_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_UNMAP_FAILURE';
export const SKI_SKISTAR_ADDONS_RESORT_LIST_PENDING = 'SKI_SKISTAR_ADDONS_RESORT_LIST_PENDING';
export const SKI_SKISTAR_ADDONS_RESORT_LIST_SUCCESS = 'SKI_SKISTAR_ADDONS_RESORT_LIST_SUCCESS';
export const SKI_SKISTAR_ADDONS_RESORT_LIST_FAILURE = 'SKI_SKISTAR_ADDONS_RESORT_LIST_FAILURE';
export const SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_PENDING = 'SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_PENDING';
export const SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_SUCCESS = 'SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_SUCCESS';
export const SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_FAILURE = 'SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_FAILURE';
export const SKI_SKISTAR_ADDONS_RESORT_ACCOMMODATION_MODAL_SHOW = 'SKI_SKISTAR_ADDONS_RESORT_ACCOMMODATION_MODAL_SHOW';
export const SKI_SKISTAR_ADDONS_RESORT_ACCOMMODATION_MODAL_CLOSE = 'SKI_SKISTAR_ADDONS_RESORT_ACCOMMODATION_MODAL_CLOSE';
export const SKI_SKISTAR_RESORT_SUBAREAS_PENDING = 'SKI_SKISTAR_RESORT_SUBAREAS_PENDING';
export const SKI_SKISTAR_RESORT_SUBAREAS_SUCCESS = 'SKI_SKISTAR_RESORT_SUBAREAS_SUCCESS';
export const SKI_SKISTAR_RESORT_SUBAREAS_FAILURE = 'SKI_SKISTAR_RESORT_SUBAREAS_FAILURE';
export const SKI_SKISTAR_RESORT_SUBAREA_CHANGE = 'SKI_SKISTAR_RESORT_SUBAREA_CHANGE';
export const SKI_SKISTAR_ADDONS_RESORT_SEARCH = 'SKI_SKISTAR_ADDONS_RESORT_SEARCH';
export const SKI_SKISTAR_ACCOMMODATION_FILTER_IMPORT_STATUS_CHANGE = 'SKI_SKISTAR_ACCOMMODATION_FILTER_IMPORT_STATUS_CHANGE';
export const SKI_SKISTAR_ACCOMMODATION_FILTER_IMAGE_STATUS_CHANGE = 'SKI_SKISTAR_ACCOMMODATION_FILTER_IMAGE_STATUS_CHANGE';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_SHOW = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_SHOW';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_CLOSE = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_CLOSE';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_ACCOMMODATION_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_ACCOMMODATION_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_ACCOMMODATION_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_ACCOMMODATION_FAILURE';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_PENDING = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_PENDING';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_SUCCESS = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_SUCCESS';
export const SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_FAILURE = 'SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_FAILURE';

// Restech
export const SKI_RESTECH_CLEAR_STATE = 'SKI_RESTECH_CLEAR_STATE';
export const SKI_RESTECH_CHANNEL_LOAD_PENDING = 'SKI_RESTECH_CHANNEL_LOAD_PENDING';
export const SKI_RESTECH_CHANNEL_LOAD_SUCCESS = 'SKI_RESTECH_CHANNEL_LOAD_SUCCESS';
export const SKI_RESTECH_CHANNEL_LOAD_FAILURE = 'SKI_RESTECH_CHANNEL_LOAD_FAILURE';
export const SKI_RESTECH_CHANNEL_CHANGE = 'SKI_RESTECH_CHANNEL_CHANGE';
export const SKI_RESTECH_CHANNEL_ADDONS_LIST_PENDING = 'SKI_RESTECH_CHANNEL_ADDONS_LIST_PENDING';
export const SKI_RESTECH_CHANNEL_ADDONS_LIST_SUCCESS = 'SKI_RESTECH_CHANNEL_ADDONS_LIST_SUCCESS';
export const SKI_RESTECH_CHANNEL_ADDONS_LIST_FAILURE = 'SKI_RESTECH_CHANNEL_ADDONS_LIST_FAILURE';
export const SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_PENDING = 'SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_PENDING';
export const SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_SUCCESS = 'SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_SUCCESS';
export const SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_FAILURE = 'SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_FAILURE';
export const SKI_RESTECH_CHANNEL_ADDONS_ACCOMMODATION_MODAL_SHOW = 'SKI_RESTECH_CHANNEL_ADDONS_ACCOMMODATION_MODAL_SHOW';
export const SKI_RESTECH_CHANNEL_ADDONS_ACCOMMODATION_MODAL_CLOSE = 'SKI_RESTECH_CHANNEL_ADDONS_ACCOMMODATION_MODAL_CLOSE';
export const SKI_RESTECH_CHANNEL_ADDONS_SEARCH = 'SKI_RESTECH_CHANNEL_ADDONS_SEARCH';

/*
  -----------------

  Twenty

  -----------------
 */
export const TWENTY_COUNTRIES_LOAD_PENDING = 'TWENTY_COUNTRIES_LOAD_PENDING';
export const TWENTY_COUNTRIES_LOAD_SUCCESS = 'TWENTY_COUNTRIES_LOAD_SUCCESS';
export const TWENTY_COUNTRIES_LOAD_FAILURE = 'TWENTY_COUNTRIES_LOAD_FAILURE';
export const TWENTY_AREAS_LOAD_PENDING = 'TWENTY_AREAS_LOAD_PENDING';
export const TWENTY_AREAS_LOAD_SUCCESS = 'TWENTY_AREAS_LOAD_SUCCESS';
export const TWENTY_AREAS_LOAD_FAILURE = 'TWENTY_AREAS_LOAD_FAILURE';
export const TWENTY_AREAS_CLEAR = 'TWENTY_AREAS_CLEAR';

// Snackbar
export const SNACKBAR_SHOW = 'SNACKBAR_SHOW';
export const SNACKBAR_HIDE = 'SNACKBAR_HIDE';



// WEBPACK FOOTER //
// ./src/store/modules/constants.js